// import _ from 'lodash';
import {
    markRaw, toRaw, compile, h
} from 'vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import { renderToString } from '@vue/server-renderer';
import merge from 'lodash/merge';
import mergeWith from 'lodash/mergeWith';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import transform from 'lodash/transform';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import uniq from 'lodash/uniq';
import uniqWith from 'lodash/uniqWith';
import toNumber from 'lodash/toNumber';
import add from 'lodash/add';
import subtract from 'lodash/subtract';
import multiply from 'lodash/multiply';
import divide from 'lodash/divide';
import round from 'lodash/round';
import min from 'lodash/min';
import max from 'lodash/max';
import mean from 'lodash/mean';
import forOwn from 'lodash/forOwn';
import get from 'lodash/get';
import set from 'lodash/set';
import pullAll from 'lodash/pullAll';
import { QueryBuilder } from "@syncfusion/ej2-vue-querybuilder";

import {
    DialogUtility, createSpinner, showSpinner, hideSpinner
} from "@syncfusion/ej2-vue-popups";
import { Toast } from "@syncfusion/ej2-notifications/src/toast/toast";
import moment from "moment";
import browser from 'browser-detect';
import { store } from "@common/store/store";
import { dialogStore } from '@common/dialogStore';
// eslint-disable-next-line import/no-extraneous-dependencies
import { StaticConfigLoader, HtmlValidate } from "html-validate/browser";

const _ = {
    merge,
    mergeWith,
    cloneDeep,
    isEqual,
    transform,
    isObject,
    isString,
    uniq,
    uniqWith,
    toNumber,
    add,
    subtract,
    multiply,
    divide,
    round,
    min,
    max,
    mean,
    forOwn,
    get,
    set,
    pullAll
};

let dialogs = {};
let toasts = {};
let objCache = {};
let geolocation = {};
let librarySessionStorage = {};
let libraryLocalStorage = {};
let libraryCaches = {};
let libraryOnunloadListeners = [];
let defaultJSMethods = [];
let logicFieldWatchers = [];
let logicCache = {};

const librarySessionStorageHandler = {
    getItem(prop) {
        let value;
        try {
            value = sessionStorage.getItem(prop);
        } catch (e) {
            value = librarySessionStorage[prop] || null;
        }
        return value;
    },
    setItem(prop, value) {
        try {
            sessionStorage.setItem(prop, value);
        } catch (e) {
            librarySessionStorage[prop] = value;
        }
    },
    removeItem(prop) {
        try {
            sessionStorage.removeItem(prop);
        } catch (e) {
            delete librarySessionStorage[prop];
        }
    },
    clear() {
        try {
            sessionStorage.clear();
        } catch (e) {
            librarySessionStorage = {};
        }
    },
    key(tmpIndex) {
        let key;
        try {
            key = sessionStorage.key(tmpIndex);
        } catch (e) {
            key = Object.keys(librarySessionStorage)[tmpIndex] || null;
        }
        return key;
    },
    getLength() {
        let length;
        try {
            length = sessionStorage.length;
        } catch (e) {
            length = Object.values(librarySessionStorage).length;
        }
        return length;
    },
    get(target, prop) {
        if (prop !== Symbol.toStringTag && prop !== Symbol.toPrimitive) {
            if (prop === 'length') {
                return this.getLength();
            }
            return typeof this[prop] === 'function' ? this[prop] : target[prop];
        }
        return target.toString();
    },
    set(target, prop, val) {
        target[prop] = val;
        return true;
    }
};

const libraryLocalStorageHandler = {
    getItem(prop) {
        let value;
        try {
            value = localStorage.getItem(prop);
        } catch (e) {
            value = libraryLocalStorage[prop] || null;
        }
        return value;
    },
    setItem(prop, value) {
        try {
            localStorage.setItem(prop, value);
        } catch (e) {
            libraryLocalStorage[prop] = value;
        }
    },
    removeItem(prop) {
        try {
            localStorage.removeItem(prop);
        } catch (e) {
            delete libraryLocalStorage[prop];
        }
    },
    clear() {
        try {
            localStorage.clear();
        } catch (e) {
            libraryLocalStorage = {};
        }
    },
    key(tmpIndex) {
        let key;
        try {
            key = localStorage.key(tmpIndex);
        } catch (e) {
            key = Object.keys(libraryLocalStorage)[tmpIndex] || null;
        }
        return key;
    },
    getLength() {
        let length;
        try {
            length = localStorage.length;
        } catch (e) {
            length = Object.values(libraryLocalStorage).length;
        }
        return length;
    },
    get(target, prop) {
        if (prop !== Symbol.toStringTag && prop !== Symbol.toPrimitive) {
            if (prop === 'length') {
                return this.getLength();
            }
            return typeof this[prop] === 'function' ? this[prop] : target[prop];
        }
        return target.toString();
    },
    set(target, prop, val) {
        target[prop] = val;
        return true;
    }
};

window.customSessionStorage = new Proxy(librarySessionStorage, librarySessionStorageHandler);
window.customLocalStorage = new Proxy(libraryLocalStorage, libraryLocalStorageHandler);

const library = {
    name: 'library',
    optimization: { // @todo add to performance monitor with send error emails
        // global
        doNotLogLastActions: false,
        enableLogicCache: false,
        storeSubscriptionsGlobaly: false,
        log: {
            methods: false, // console.log(cId, methodName, ms)
            computed: false, // console.log(cId, set/get, computed, ms)
            props: false, // console.log(cId, set/get, prop, ms),
            logic: false
        },
        // itemList
        disableItemListLogic: false, // use with test records only!!!
        // itemListUseGlobalFunctions: false,
        itemListUseTmpComputedWhileSubscriptions: true,
        itemListDisableOnSubscriptions: true,
        // itemListDontUpdatePropsIfNoChanges: false,
        // itemListUseTemplateFnc: false
    },
    addUnLoadEvent: function (funcOnUnLoad, isEarlier) {
        if (typeof funcOnUnLoad !== 'function' || libraryOnunloadListeners.includes(funcOnUnLoad.name)) return;// avoid duplicates
        window.addEventListener('pagehide', () => {
            funcOnUnLoad();
        });
        libraryOnunloadListeners.push(funcOnUnLoad.name);
    },
    mergeObj: function () {
        return _.merge(...arguments);
    },
    mergeWith: function () {
        return _.mergeWith(...arguments);
    },
    cloneObj: function (inObject, toRaw, markAsRaw) {
        let result;
        if (toRaw) {
            inObject = library.toRaw(inObject);
        }
        try {
            result = _.cloneDeep(inObject);
        } catch (e) {
            result = inObject;
        }
        return markAsRaw && typeof result === 'object' ? markRaw(result) : result;
    },
    toRaw: function (inObject) {
        return toRaw(inObject);
    },
    markRaw: function (inObject) {
        return markRaw(inObject);
    },
    isEqualObj: function (inObject1, inObject2) {
        let tmpObj1 = library.cloneObj(inObject1);
        let tmpObj2 = library.cloneObj(inObject2);
        return _.isEqual(tmpObj1, tmpObj2);
    },
    filterObj: function (tmpObj, keys, removeKeys) {
        if (typeof tmpObj !== 'object' || !keys) return tmpObj;
        if (keys && !Array.isArray(keys)) keys = [keys];
        if (typeof removeKeys === 'undefined') removeKeys = false;
        return Object.fromEntries(Object.entries(tmpObj).filter(([key]) => (removeKeys ? keys.indexOf(key) === -1 : keys.indexOf(key) !== -1)));
    },
    lodash: function () {
        return _;
    },
    isDate: function (value) {
        let isDate = false;
        const formats = library.getDateFormats();
        if (!value || value === 'Invalid date') return isDate; // also excludes null
        // Evaluate number dates
        // Use a big number to hopefully exclude normal number values
        // The number 946684800000 represents date 2000-01-01
        if (typeof value === 'number' && value > 946684800000) return true; // NOSONAR
        if (typeof value === 'object') {
            if (typeof value.getMonth === 'function' && isNaN(value.getMonth()) === false) isDate = true;
        }
        else if (typeof value === 'string') {
            for (let i in formats) {
                if (i === 'length') continue;
                isDate = moment(value, formats[i], true).isValid();
                if (isDate) break;
            }
        }
        return isDate;
    },
    difference: function (object, base) {
        return _.transform(object, (result, value, key) => {
            if (!_.isEqual(value, base[key])) {
                result[key] = _.isObject(value) && _.isObject(base[key]) ? library.difference(value, base[key]) : value;
            }
        });
    },
    arrayDifference: function (array1, array2) {
        const difference1 = array1.filter((value) => !array2.includes(value));
        const difference2 = array2.filter((value) => !array1.includes(value));
        return [...difference1, ...difference2]; // Combines elements unique to either array
    },
    setCookie: /* istanbul ignore next */ function (name, value, path) {
        if (typeof IS_JEST !== 'undefined') return;
        document.cookie = name + "=" + value + ";" + (path ? "path=" + path + ";" : "path=/;"); // NOSONAR
    },
    getCookie: /* istanbul ignore next */ function (name) {
        if (typeof IS_JEST !== 'undefined') return '';
        let result;
        let matches = document.cookie.match(new RegExp(
            // eslint-disable-next-line no-useless-escape
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"
        ));
        if (matches && matches[1]) {
            result = matches[1];
        }
        return result;
    },
    sleep: /* istanbul ignore next */ function (ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    },
    changeNewLineToBr: function (str) {
        return str.replace('\n', '<br/>');
    },
    objIsEmpty: function (inObject) {
        if (typeof inObject === 'number' && inObject) return false;
        if (typeof inObject === 'string' && inObject) return false;
        for (let prop in inObject) {
            if (prop === 'length') continue;
            if (inObject.hasOwnProperty(prop)) return false;
        }
        return true;
    },
    sortObject: function (inObject, sortBy, direction = 'asc', withoutCheckDate = false) {
        let sortByProperty = sortBy;
        if (!Array.isArray(sortBy)) {
            sortByProperty = [sortBy];
        }
        let sortFunction = function (a, b) {
            let comparison;
            let checkComparison = function (prop1, prop2) {
                let output = 0;
                if (prop1 instanceof Date) prop1 = prop1.getTime();
                if (prop2 instanceof Date) prop2 = prop2.getTime();

                if (typeof prop1 === 'number') output = prop1 - prop2;
                else if (typeof prop2 === 'number') output = 1;
                // if props are dates
                else if (!withoutCheckDate && library.isDate(prop1) && library.isDate(prop2)) {
                    const date1 = moment(prop1);
                    const date2 = moment(prop2);
                    if (date1.isAfter(date2)) output = 1;
                    else output = -1;
                }
                else {
                    // Default string compare
                    let bandA = prop1 ? prop1.toUpperCase() : undefined;
                    let bandB = prop2 ? prop2.toUpperCase() : undefined;
                    if (bandA > bandB) {
                        output = 1;
                    } else if (bandA < bandB) {
                        output = -1;
                    }
                }
                return output;
            };
            comparison = checkComparison(a[sortByProperty[0]], b[sortByProperty[0]]);
            let sortByAnotherProperty = library.cloneObj(sortByProperty);
            sortByAnotherProperty.shift();
            while (comparison === 0 && sortByAnotherProperty.length) {
                comparison = checkComparison(a[sortByAnotherProperty[0]], b[sortByAnotherProperty[0]]);
                sortByAnotherProperty.shift();
            }
            return comparison;
        };
        let sorted;
        if (typeof inObject[0] === 'string') {
            sorted = inObject.sort();
        }
        else if (typeof inObject[0] === 'number') {
            sorted = inObject.sort((a, b) => a - b);
        }
        else sorted = inObject.sort(sortFunction);
        // Set direction
        if (direction === 'desc' || direction === 'Descending') sorted = sorted.reverse();
        return sorted;
    },
    jsIncluded: /* istanbul ignore next */ function (file) {
        let scripts = document.getElementsByTagName("script");
        for (let i = 0; i < scripts.length; i++) {
            if (scripts[i].src.substr(-file.length) === file) return true;
        }
        return false;
    },
    loadScript: /* istanbul ignore next */ function (src) {
        return new Promise(function (resolve, reject) {
            // Create script element and set attributes
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = src;
            document.body.appendChild(script);

            // Resolve the promise once the script is loaded
            script.addEventListener('load', function () {
                resolve(script);
            });

            // Catch any errors while loading the script
            script.addEventListener('error', () => {
                reject(new Error(src + ' failed to load.'));
            });
        });
    },
    /* istanbul ignore next */
    async jsInclude(files) {
        for (let i in files) {
            if (i === 'length') continue;
            // eslint-disable-next-line no-await-in-loop
            let included = await library.jsIncluded(files[i]);
            if (!included) {
                // eslint-disable-next-line no-await-in-loop
                await library.loadScript(files[i]);
            }
        }
        return true;
    },
    getDialog(name) {
        if (name) {
            return dialogs[name];
        }
        return dialogs;
    },
    getDialogs() {
        return dialogs;
    },
    async showDialog(msg, funcOnSuccess, funcOnFailure, opt, funcPreSuccess, funcPostClose, funcOpen) {
        let compName;
        if (typeof msg === 'object' && msg.name && msg.template) {
            compName = msg.name;
        }
        if (!opt) opt = {};
        let name = opt['name'] || compName || 'default';
        if (opt['useSingletonPromise'] && name !== 'default' && typeof dialogs?.[name]?.promise !== 'undefined') {
            return dialogs[name].promise;
        }
        if (!funcOpen && opt['funcOpen']) funcOpen = opt['funcOpen'];
        if (!funcPostClose && opt['funcPostClose']) funcPostClose = opt['funcPostClose'];
        let tmpPromise = new Promise((resolve) => {
            if (!msg) return;
            let content = msg;
            // if component was passed
            if (typeof msg === 'object' && msg.name && msg.template) {
                if (!opt.isComponentDialog) {
                    // TODO: can we get rid of this?
                    for (let i in vueApp._context.components) {
                        if (i === 'length') continue;
                        if (typeof msg.components === 'undefined') msg.components = {};
                        if (typeof msg.components[i] === 'undefined') {
                            msg.components[i] = vueApp._context.components[i];
                        }
                    }
                }
                let tmpCmp = vueApp.component(msg.name, msg);
                let tmpFunc = function () {
                    return {
                        template: tmpCmp
                    };
                };
                Object.defineProperty(tmpFunc, "name", { value: msg.name });
                content = tmpFunc;
            } else if (typeof msg === 'string') {
                let tmpMsg = msg.replace(/"/g, "''");
                content = library.removeDoubleSpaces(tmpMsg);
            }
            if (typeof dialogs[name] !== 'undefined' && typeof dialogs[name].dialog !== 'undefined' && typeof dialogs[name].dialog.hide === 'function') {
                dialogStore().closeDialog(name);
                dialogs[name].dialog.hide();
                delete dialogs[name];
            }
            let hideOnClickOutside = function (event) {
                if (event && event.target && event.target.className && typeof event.target.className.indexOf === 'function' && event.target.className.indexOf('e-dlg-overlay') !== -1) {
                    if (dialogs[name] && typeof dialogs[name].cancel === 'function') dialogs[name].close('outsideClick');
                    document.removeEventListener("click", hideOnClickOutside);
                }
            };
            // TODO: Possibly replace this with isModal =  'modal'/'modeless'
            if (!opt.preventCloseOnBackdropClick) document.addEventListener("click", hideOnClickOutside);
            let response = {
                status: 'failure',
                eventTrigger: 'systematic',
                funcPreSuccess: null,
                funcOnSuccess: null,
                funcOnFailure: null,
            };
            let cssClass = '';
            if (opt.cssClass) cssClass += ' ' + opt.cssClass;
            if (opt.size) cssClass += ' ' + opt.size + '-dialog';
            cssClass = cssClass.trim();
            let formatResponse = (iResponse) => {
                if (typeof iResponse === 'object') {
                    if (!iResponse.status) iResponse.status = 'success';
                    return iResponse;
                }
                let defaultResponse = {
                    status: 'success', // default to "success" when no response from dialog close hook function is returned
                    message: iResponse
                };
                if (typeof iResponse !== 'undefined') defaultResponse.iResponse = iResponse ? 'success' : 'failure';
                return defaultResponse;
            };
            let isFullScreen = opt.size === 'fullscreen'
                || (opt['cssClass'] && opt['cssClass'].indexOf('fullscreen-dialog') !== -1);
            dialogs[name] = {
                success: async function (eventTrigger) {
                    dialogs[name].toggleButtons(true);
                    response.status = 'success';
                    if (eventTrigger) response.eventTrigger = eventTrigger;
                    if (typeof funcPreSuccess === 'function') {
                        let funcResponse = await funcPreSuccess(dialogs[name]);
                        response.funcPreSuccess = formatResponse(funcResponse);
                        if (response.funcPreSuccess.status === 'failure') {
                            response.status = 'failure';
                        }
                        if (opt['doNotCloseOnFuncFailure'] && response.funcPreSuccess.status === 'failure') {
                            if (typeof dialogs?.[name]?.toggleButtons === 'function') dialogs[name].toggleButtons(false);
                            return;
                        }
                    }
                    if (typeof funcOnSuccess === 'function') {
                        let funcResponse = await funcOnSuccess(dialogs[name]);
                        response.funcOnSuccess = formatResponse(funcResponse);
                        if (response.funcOnSuccess.status === 'failure') {
                            response.status = 'failure';
                        }
                        if (opt['doNotCloseOnFuncFailure'] && response.funcOnSuccess.status === 'failure') {
                            if (typeof dialogs?.[name]?.toggleButtons === 'function') dialogs[name].toggleButtons(false);
                            return;
                        }
                    }
                    let closeAfterSeconds = parseInt(opt['closeAfterSeconds'], 10) ? parseInt(opt['closeAfterSeconds'], 10) : 0;
                    if (closeAfterSeconds > 0) dialogs[name].willCloseAfterTimeout = true;
                    setTimeout(() => {
                        if (dialogs[name]) {
                            dialogs[name].willCloseAfterTimeout = false;
                            if (typeof dialogs[name].toggleButtons === 'function') dialogs[name].toggleButtons(false);
                            dialogStore().closeDialog(name);
                            dialogs[name].dialog.hide();
                            delete dialogs[name];
                        }
                    }, closeAfterSeconds * 1000);
                },
                toggleButtons: function (flag) {
                    if (dialogs && dialogs[name] && dialogs[name].dialog && typeof dialogs[name].dialog.btnObj !== 'undefined') {
                        for (let i in dialogs[name].dialog.btnObj) {
                            if (i === 'length') continue;
                            dialogs[name].dialog.btnObj[i].disabled = flag;
                        }
                    }
                },
                close: async function (eventTrigger) {
                    if (dialogs[name].willCloseAfterTimeout) return;
                    dialogs[name].toggleButtons(true);
                    response.status = 'failure';
                    if (eventTrigger) response.eventTrigger = eventTrigger;
                    if (typeof funcOnFailure === 'function') {
                        let funcResponse = await funcOnFailure();
                        response.funcOnFailure = formatResponse(funcResponse);
                        if (opt['doNotCloseOnFuncCloseFailure'] && response.funcOnFailure.status === 'failure') {
                            dialogs[name].toggleButtons(false);
                            return;
                        }
                    }
                    dialogStore().closeDialog(name);
                    if (typeof dialogs[name]?.dialog?.hide === 'function') dialogs[name].dialog.hide();
                    if (typeof dialogs[name]?.toggleButtons === 'function') dialogs[name].toggleButtons(false);
                    delete dialogs[name];
                },
                okButton: async function (event) {
                    let buttonResult = opt.okButtonFunction
                        ? await opt.okButtonFunction()
                        : { status: 'success' };
                    if (buttonResult.status !== 'success') return;
                    if (opt.doNotCloseOnOK && event && event.keyCode === 13) {
                        return;
                    }
                    if (typeof dialogs?.[name]?.success === 'function') await dialogs[name].success('okButton');
                },
                cancelButton: async function () {
                    if (typeof dialogs?.[name] !== 'undefined') await dialogs[name].close('cancelButton');
                }
            };
            if (opt.hideTitle) opt['title'] = ' ';
            let dialogSettings = {
                name,
                compName,
                isComponentDialog: opt.isComponentDialog,
                title: opt['title'] ? opt['title'] : 'Confirm to Continue',
                content: content,
                okButton: {
                    text: opt['okButtonLabel'] ? opt['okButtonLabel'] : 'Ok',
                    cssClass: opt['okButtonCssClass'],
                    click: dialogs[name].okButton
                },
                cancelButton: {
                    text: opt['cancelButtonLabel'] ? opt['cancelButtonLabel'] : 'Cancel',
                    cssClass: opt['cancelButtonCssClass'],
                    click: dialogs[name].cancelButton
                },
                async close() {
                    if (typeof funcOnFailure === 'function' && response.status === 'failure' && !response.funcOnFailure) {
                        let funcResponse = await funcOnFailure();
                        response.funcOnFailure = formatResponse(funcResponse);
                    }
                    if (typeof funcPostClose === 'function') funcPostClose();
                    dialogStore().closeDialog(name);
                    resolve(response);
                },
                open() {
                    dialogStore().openDialog(name);
                    if (opt.width && !isFullScreen) {
                        this.width = opt.width;
                    }
                    if (opt.height && !isFullScreen) {
                        this.height = opt.height;
                        if (typeof this.element?.style?.maxHeight !== 'undefined') this.element.style.maxHeight = opt.height;
                    }
                    if (!opt.hideOpenInNewWindow && typeof opt.openInNewWindowFnc === 'function') {
                        let tmpHeader = this.element.getElementsByClassName('e-dlg-header-content')[0];
                        let openInNewWindowElem = document.createElement("div");
                        openInNewWindowElem.classList.add("popup-open-in-new-window");
                        openInNewWindowElem.onclick = () => {
                            opt.openInNewWindowFnc();
                        };
                        openInNewWindowElem.innerHTML = '<button class="e-dlg-closeicon-btn e-control e-btn e-lib e-flat e-icon-btn" type="button" title="Open in new window" aria-label="Open in new window" data-ripple="true"><span class="e-btn-icon e-open-link e-icons"></span></button>';
                        tmpHeader.appendChild(openInNewWindowElem);
                    }
                    if (opt.resizeDialogToIframeHeight) {
                        let iframeAppearInterval = setInterval(() => {
                            let frameElem = document.getElementById(opt.resizeDialogToIframeHeight);
                            if (frameElem) {
                                clearInterval(iframeAppearInterval);
                                if (frameElem && frameElem?.tagName === 'IFRAME') {
                                    let tmpDialogId = this?.element?.id || 'body';
                                    library.showLoadingIndicator(tmpDialogId);
                                    let oldOnload = frameElem.onload;
                                    frameElem.onload = () => {
                                        library.resizeDialogToIframeHeight(opt.resizeDialogToIframeHeight);
                                        if (typeof oldOnload === 'function') oldOnload();
                                        library.hideLoadingIndicator(tmpDialogId);
                                    };
                                } else {
                                    library.resizeDialogToIframeHeight(opt.resizeDialogToIframeHeight);
                                }
                            }
                        }, 100);
                    }
                    if (opt.resizeDialogToIframeWidth && this.width === 'auto') library.resizeDialogToIframeWidth(opt.resizeDialogToIframeWidth, this);
                    if (typeof funcOpen === 'function') funcOpen(this);
                },
                showCloseIcon: typeof opt['showCloseIcon'] !== 'undefined' ? opt['showCloseIcon'] : true,
                closeOnEscape: typeof opt['closeOnEscape'] !== 'undefined' ? opt['closeOnEscape'] : true,
                cssClass: cssClass,
                animationSettings: { effect: 'Zoom' },
                zIndex: opt['zIndex'] ? opt['zIndex'] : 10000000, // NOSONAR
            };
            if (opt.isComponentDialog) {
                let fullScreenStyles = isFullScreen ? 'style="height: 100%;"' : '';
                dialogSettings.content = '<div id="dialog_container_' + name + '" ' + fullScreenStyles + '></div>';
                dialogStore().createDialog(name, dialogSettings);
            }

            dialogs[name].dialog = (
                typeof opt['showAsAlert'] !== 'undefined' && opt['showAsAlert']
            ) ? DialogUtility.alert(dialogSettings) : DialogUtility.confirm(dialogSettings);
            dialogs[name].dialog.beforeClose = () => {
                dialogStore().closeDialog(name);
            };
            if (typeof opt['doLocalAction'] === 'function') {
                dialogs[name]['doLocalAction'] = opt['doLocalAction'];
            }
        });
        dialogs[name].promise = tmpPromise;
        return tmpPromise;
    },
    hideDialog: /* istanbul ignore next */ async function (name, isSuccess, eventTrigger, onlyHide, params) {
        if (typeof dialogs[name] !== 'undefined') {
            if (typeof dialogs[name].doLocalAction !== 'undefined') {
                dialogs[name].doLocalAction(name, params);
            }
            if (onlyHide) {
                dialogStore().closeDialog(name);
                dialogs[name].dialog.hide();
            }
            else if (isSuccess) dialogs[name].success(eventTrigger || 'systematic');
            else dialogs[name].close(eventTrigger || 'systematic');
        }
    },
    hideAllDialogs: /* istanbul ignore next */ function () {
        for (let i in dialogs) {
            if (i === 'length') continue;
            if (typeof dialogs[i] !== 'undefined' && typeof dialogs[i].close === 'function') {
                dialogs[i].close('hideAll');
                // delete dialogs[i];
            }
        }
    },
    resizeDialogToIframeHeight(elemID) {
        // Use an interval because heights change dynamically
        let popupResizeInterval = setInterval(() => {
            let frameWrapperElem = document.getElementById(elemID);
            if (frameWrapperElem) {
                let popUpContentElem = frameWrapperElem.closest('.e-dlg-content');
                let popUpElem = frameWrapperElem.closest('.e-dialog');
                let popupMargin = 60;
                let popupHeaderHeight = 0;
                let popupButtonsHeight = 0;
                let windowHeight = window.screen.availHeight;
                if (popUpElem) {
                    let popupHeader = popUpElem.querySelectorAll('.e-dlg-header-content');
                    if (popupHeader && popupHeader[0]) {
                        popupHeaderHeight = popupHeader[0].clientHeight;
                    }
                    let popupButtons = popUpElem.querySelectorAll('.e-footer-content');
                    if (popupButtons && popupButtons[0]) {
                        popupButtonsHeight = popupButtons[0].clientHeight;
                    }
                }
                if (popUpContentElem) {
                    let frameBody = frameWrapperElem.contentDocument && frameWrapperElem.contentDocument.body;
                    if (frameBody) {
                        let iframeHeight = frameBody.clientHeight + 30;
                        if (iframeHeight < 300) iframeHeight = 300;
                        let maxHeight = windowHeight - popupMargin - popupHeaderHeight - popupButtonsHeight;
                        if (iframeHeight > maxHeight) iframeHeight = maxHeight;
                        popUpContentElem.style.height = iframeHeight + 'px';
                    }
                }
            } else {
                clearInterval(popupResizeInterval);
            }
        }, 500); // NOSONAR
    },
    resizeDialogToIframeWidth(elemID, _this) {
        // Use an interval because heights change dynamically
        let popupResizeInterval = setInterval(() => {
            let frameWrapperElem = document.getElementById(elemID);
            if (frameWrapperElem) {
                let popUpElem = frameWrapperElem.closest('.e-dlg-content');
                if (popUpElem) {
                    let frameBody = frameWrapperElem.contentDocument && frameWrapperElem.contentDocument.body;
                    if (frameBody && frameBody.scrollWidth > frameBody.clientWidth) {
                        let iframeWidth = frameBody.scrollWidth + 50;
                        _this.width = iframeWidth + 'px';
                    }
                }
            } else {
                clearInterval(popupResizeInterval);
            }
        }, 500); // NOSONAR
    },
    showToast: /* istanbul ignore next */function (msg, opt) {
        if (!opt) opt = {};
        if (!msg && !opt.templateElemId) return false;
        const name = opt['name'] || msg || 'default';
        if (typeof toasts[name] !== 'undefined') {
            return toasts[name];
        }
        if (!document.getElementById("toasts")) {
            const elem = document.createElement('div');
            elem.id = "toasts";
            document.body.appendChild(elem);
        }
        const position = opt['position'] ? opt['position'] : { X: 'Right', Y: 'Top' };
        const target = opt['target'] && document.getElementById(opt['target']) ? document.getElementById(opt['target']) : document.body;
        const timeout = opt['timeout'] ? opt['timeout'] * 1000 : 20000; // NOSONAR
        const width = opt['width'] || 300;
        const newestOnTop = opt['newestOnTop'] ? opt['newestOnTop'] : true;
        const showProgressBar = opt['showProgressBar'] !== 'undefined' ? opt['showProgressBar'] : false;
        const showCloseButton = opt['showCloseButton'] !== 'undefined' ? opt['showCloseButton'] : false;
        let cssClass = 'e-toast-info';
        if (opt['type']) {
            switch (opt['type']) {
                case "danger":
                    cssClass = 'e-toast-danger';
                    break;
                case "success":
                    cssClass = 'e-toast-success';
                    break;
                case "warning":
                    cssClass = 'e-toast-warning';
                    break;
            }
        }
        if (opt.cssClass) cssClass += ' ' + opt.cssClass;
        if (library.isHTML(msg) && !opt.templateElemId) {
            const htmlToastID = "toasts_" + (opt['name'] || library.getUniqueID());
            const existingToastWithSameID = document.getElementById(htmlToastID);
            const elem = existingToastWithSameID || document.createElement('div');
            elem.innerHTML = msg;
            elem.id = htmlToastID;
            elem.style.display = "none";
            if (!existingToastWithSameID) {
                document.body.appendChild(elem);
            }
            opt.templateElemId = "#" + htmlToastID;
        }
        const toast = new Toast({
            template: opt.templateElemId || "<div>" + msg + "</div>",
            position: position,
            target: target,
            extendedTimeout: 0,
            width: width,
            timeOut: timeout,
            newestOnTop: newestOnTop,
            showProgressBar: showProgressBar,
            showCloseButton: showCloseButton,
            cssClass: cssClass,
            beforeClose: (event) => {
                if (typeof opt['onBeforeClose'] === 'function') opt['onBeforeClose']();
                if (typeof opt['onXClose'] === 'function' && event.type === 'click') opt['onXClose']();
            },
            close: () => {
                if (typeof opt['onClose'] === 'function') opt['onClose']();
                delete toasts[name];
            }
        });
        toasts[name] = toast;
        toast.appendTo('#toasts');
        toast.show();
        return toast;
    },
    /* istanbul ignore next */
    getToast: function (name) {
        return toasts && toasts[name];
    },
    getAllToasts: function (name) {
        return toasts;
    },
    hideToast: /* istanbul ignore next */function (name) {
        if (name instanceof RegExp && toasts) {
            for (let i in toasts) {
                if (name.test(i)) toasts[i].hide();
            }
        } else if (toasts && toasts[name] && typeof toasts[name].hide === 'function') {
            toasts[name].hide();
        }
    },
    hideAllToasts: /* istanbul ignore next */function () {
        if (toasts) {
            for (let i in toasts) {
                if (typeof toasts[i].hide === 'function') {
                    toasts[i].hide();
                }
            }
        }
    },
    exportFile: /* istanbul ignore next */function (filename, content) {
        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    },
    uniqueArray: function (arr) {
        return _.uniq(arr);
    },
    uniqueArrayWithObjects: function (arr) {
        return _.uniqWith(arr, _.isEqual);
    },
    // calcSourceParser: function (numSource, prevCalcResults) {
    //     let val = null;
    //     if (!isNaN(numSource)) val = Number(numSource);
    //     else {
    //         let parsedSrc = numSource.replace('this.', '');
    //         let iVal;
    //         if (parsedSrc.indexOf('prevCalcResults') !== -1) {
    //             let prevCalcIndex = parsedSrc.replace(/\D/g, '');
    //             iVal = prevCalcResults[prevCalcIndex];
    //         }
    //         else iVal = library.getByPath(this, parsedSrc);
    //         iVal = Number(iVal);
    //         if (!isNaN(iVal)) val = iVal;
    //     }
    //     return val;
    // },
    // parseCalcItems: function (calcItems) {
    //     let product = null;
    //     if (!calcItems || calcItems.length === 0) return product;
    //     let prevCalcResults = [];
    //     calcItems.forEach((iCalcItem, index) => {
    //         product = library.calcParser.call(this, iCalcItem.fields, iCalcItem.type, prevCalcResults);
    //         prevCalcResults[index] = product;
    //     });
    //     return product;
    // },
    calcParser: function (calculationItems) {
        let calcSourceParser = (numSource, prevCalcResults) => {
            let val = null;
            if (!isNaN(numSource)) val = Number(numSource);
            else {
                let parsedSrc = numSource.replace('this.', '');
                let iVal;
                if (parsedSrc.indexOf('prevCalcResults') !== -1) {
                    let prevCalcIndex = parsedSrc.replace(/\D/g, '');
                    iVal = prevCalcResults[prevCalcIndex];
                }
                else iVal = library.getByPath(this, parsedSrc);
                iVal = Number(iVal);
                if (!isNaN(iVal)) val = iVal;
            }
            return val;
        };
        let processCalcItem = (numberSources, operator, prevCalcResults) => {
            // Return null if there is not at least two entries in numberSources
            // NumberSource should be an array (eg: [5, 'this.someField.value'])
            let product = null;
            let minSources = 2;
            let numSrcLen = numberSources.length;
            if (numSrcLen < minSources) return product; // NOSONAR
            // Convert numberSources to an array of numbers
            let vals = numberSources.map((nSource) => calcSourceParser.call(this, nSource, prevCalcResults));
            // Normalize the operator for some calculations
            let realOperator;
            if (operator === 'average') operator = 'mean';
            if (operator === 'percentage' || operator === 'percent') {
                operator = 'divide';
                realOperator = 'percent';
            }
            // Calculate the value
            // Uses lodash math
            // https://lodash.com/docs/4.17.15#add
            // eg: _.divide(val1, val2)
            // Iterate through all sources and do calculations
            if (operator === 'min' || operator === 'max' || operator === 'mean') {
                product = _[operator](vals);
            }
            else if (operator === 'round') {
                product = _[operator](vals[0], vals[1]);
            }
            else {
                // Get first value for product
                product = vals[0];
                // Do calculations in sequence on rest of numbers
                for (let i = 1; i < numSrcLen; i++) {
                    let nextVal = vals[i];
                    product = _[operator](product, nextVal);
                }
                if (realOperator === 'percent') product *= 100; // NOSONAR
            }
            return product;
        };
        let parseCalcItems = (calcItems) => {
            let product = null;
            if (!calcItems || calcItems.length === 0) return product;
            let prevCalcResults = [];
            calcItems.forEach((iCalcItem, index) => {
                product = processCalcItem.call(this, iCalcItem.fields, iCalcItem.type, prevCalcResults);
                prevCalcResults[index] = product;
            });
            return product;
        };
        return parseCalcItems(calculationItems);
    },
    capitalizeFirstLetter: /* istanbul ignore next */function (string) {
        if (typeof string !== 'string') return string;
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    lowerFirstLetter: /* istanbul ignore next */function (string) {
        if (typeof string !== 'string') return string;
        return string.charAt(0).toLowerCase() + string.slice(1);
    },
    titleCase(string) {
        return string.toLowerCase().split(' ')
            .map((word) => word.replace(word[0], word[0].toUpperCase()))
            .join(' ');
    },
    kebabCase(string) {
        return string.split('').map((letter, idx) => (letter.toUpperCase() === letter
            ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
            : letter)).join('');
    },
    camelCase(string) {
        return string
            .split(/[-\s]+/) // split on dash OR whitespace
            .map((strPart, idx) => {
                if (!strPart) return ''; // safety for extra spaces
                if (idx === 0) {
                    return strPart.toLowerCase();
                }
                return strPart[0].toUpperCase() + strPart.slice(1).toLowerCase();
            })
            .join('');
    },
    copyTextToClipboard: /* istanbul ignore next */function (text) {
        let textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.top = 0;
        textArea.style.left = 0;
        textArea.style.width = '2em';
        textArea.style.height = '2em';
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';
        textArea.style.background = 'transparent';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
    },
    disableAllUserEvents: function (objId) {
        if (!objId || !library.getElementById(objId)) return;
        let tmpObject = library.getElementById(objId);
        const events = ["click", "contextmenu", "dblclick", "mousedown", "mouseenter", "mouseleave", "mousemove",
            "mouseover", "mouseout", "mouseup", "keydown", "keypress", "keyup", "blur", "change", "focus", "focusin",
            "focusout", "input", "invalid", "reset", "search", "select", "submit", "drag", "dragend", "dragenter",
            "dragleave", "dragover", "dragstart", "drop", "copy", "cut", "paste", "mousewheel", "wheel", "touchcancel",
            "touchend", "touchmove", "touchstart"];

        const handler = (event) => {
            event.stopPropagation();
            event.preventDefault();

            return false;
        };
        for (let i = 0, l = events.length; i < l; i++) {
            tmpObject.addEventListener(events[i], handler, true);
        }
    },
    addBodySpinners: function () {
        let bodySpinners = document.getElementById('bodySpinners');
        if (!bodySpinners) {
            let bodySpinnersEl = document.createElement('div');
            bodySpinnersEl.id = 'bodySpinners';
            document.body.appendChild(bodySpinnersEl);
            // library.disableAllUserEvents('bodySpinners');
        }
    },
    showLoadingIndicator: /* istanbul ignore next */ function (objId, hideAfterSec, message, addClass) {
        if (typeof IS_JEST !== 'undefined') return;
        if (!objId) objId = 'app';
        if (!library.getElementById(objId) && objId !== 'body') return;
        if (objId === 'body') {
            library.addBodySpinners();
            objId = 'bodySpinners';
        }
        let spinnerWrapperObj = library.getElementById(objId);
        let spinnerElements = spinnerWrapperObj.getElementsByClassName('e-spinner-pane');
        for (let i = spinnerElements.length - 1; i >= 0; i--) {
            if (typeof spinnerElements[i].remove === 'function') {
                spinnerElements[i].remove();
            }
        }
        // eslint-disable-next-line max-len
        let defaultSpinnerTemplate = '<svg class="e-spin-material" id="Lenwo" viewBox="0 0 30 30" style="height: 30px; width: 30px; transform-origin: 15px 15px 15px;"><path class="e-path-circle" d="M15,1.5A13.5,13.5 0 1 1 1.5,15" stroke-width="3" stroke-dasharray="63.61725123519331" stroke-dashoffset="170.50391184173657" transform="rotate(-270 15 15)"></path></svg>';
        let tmpSpinnerTemplate = defaultSpinnerTemplate;
        if (message) tmpSpinnerTemplate += '<div class="spinner-message">' + message + '</div>';

        createSpinner({
            target: spinnerWrapperObj,
            template: tmpSpinnerTemplate
        });
        showSpinner(spinnerWrapperObj);
        if (addClass) {
            let spinnerElements = spinnerWrapperObj.getElementsByClassName('e-spinner-pane');
            for (let i = spinnerElements.length - 1; i >= 0; i--) {
                if (spinnerElements[i].classList && typeof spinnerElements[i].classList.add === 'function') {
                    spinnerElements[i].classList.add(addClass);
                }
            }
        }
        if (hideAfterSec) {
            setInterval(function () {
                hideSpinner(spinnerWrapperObj);
            }, hideAfterSec * 1000); // NOSONAR
        }
    },
    hideLoadingIndicator: /* istanbul ignore next */ function (objId) {
        if (typeof IS_JEST !== 'undefined') return;
        if (!objId) objId = 'app';
        if (!library.getElementById(objId) && objId !== 'body') return;
        if (objId === 'body') {
            objId = 'bodySpinners';
        }
        let spinnerWrapperObj = library.getElementById(objId);
        hideSpinner(spinnerWrapperObj);
        let spinnerElements = spinnerWrapperObj.getElementsByClassName('e-spinner-pane');
        for (let i = spinnerElements.length - 1; i >= 0; i--) {
            if (typeof spinnerElements[i].remove === 'function') {
                spinnerElements[i].remove();
            }
        }
    },
    getElementById: /* istanbul ignore next */ function (ID) {
        if (!objCache[ID]) {
            library.putObjectCache(document.getElementById(ID));
        } else if (objCache[ID] && !objCache[ID].parentNode) {
            library.clearObjectCache();
            library.putObjectCache(document.getElementById(ID));
        }
        return objCache[ID];
    },
    clearObjectCache: /* istanbul ignore next */ function () {
        for (let objID in objCache) {
            if (objID === 'length') continue;
            objCache[objID] = null;
            delete objCache[objID];
        }
        objCache = {};
    },
    putObjectCache: /* istanbul ignore next */ function (obj) {
        if (obj && obj.id && obj.parentNode) {
            objCache[obj.id] = obj;
        }
    },
    urlParser: {
        getParams(paramName) {
            let params = [];
            if (typeof location !== 'undefined') {
                location.search
                    .substr(1)
                    .split("&")
                    .forEach(function (item) {
                        let param = item.split("=");
                        params[param[0]] = decodeURIComponent(param[1]);
                    });
            }
            if (paramName) {
                return typeof params[paramName] !== 'undefined' ? params[paramName] : undefined;
            }
            return params;
        },
        async parse(cId) {
            let output = {};
            let quickLinkData = false;
            let getParams = library.urlParser.getParams();
            if (getParams && (getParams['quicklink'] || (getParams['repeater'] && getParams['instance']))) {
                let tmpGetParam = getParams['quicklink'] ? 'quicklink' : 'repeater';
                let tmpInstance = getParams['instance'] || false;
                if (tmpInstance) {
                    let response = await sDs.post('sds_getDevDashLocalInstanceDetails');
                    if (response.status === 'success' && response.data && response.data.name !== tmpInstance && typeof actionStore !== 'undefined') {
                        actionStore.logout('user');
                    }
                }
                let crcParams = await configStore.getDevDashStateCrcParams(getParams[tmpGetParam], tmpInstance);
                if (crcParams) {
                    quickLinkData = JSON.stringify(library.cloneObj(crcParams));
                    if (crcParams.jiraTicketUrl && library.objIsEmpty(errorHandler.get('jiraTicketInfo'))) {
                        let jiraTicketInfo = {};
                        if (!library.objIsEmpty(crcParams.jiraTicketInfo)) {
                            jiraTicketInfo = library.cloneObj(crcParams.jiraTicketInfo);
                        } else {
                            jiraTicketInfo['url'] = crcParams.jiraTicketUrl;
                            jiraTicketInfo['link'] = '<a href="' + jiraTicketInfo['url'] + '" target="_blank">' + jiraTicketInfo['url'] + '</a>';
                        }
                        library.showToast('Following JIRA ticket is attached to the quicklink: <br/>' + jiraTicketInfo['link'], { timeout: 180 });
                        errorHandler.set('jiraTicketInfo', jiraTicketInfo);
                    }
                    if (tmpInstance && typeof errorHandler !== 'undefined' && crcParams.repeatComponentID) {
                        errorHandler.set('isRepeat', true);
                        errorHandler.set('repeatComponentID', crcParams.repeatComponentID);
                        errorHandler.set('lastActions', crcParams.lastActions);
                        errorHandler.set('lastRequests', crcParams.lastRequests);
                        if (crcParams.callStackForConsole && Array.isArray(crcParams.callStackForConsole)) {
                            errorHandler.showRepeaterCallstack(crcParams.callStackForConsole);
                        }
                    }
                }
            }
            if (location.search || quickLinkData) {
                let json = '';
                if (quickLinkData) {
                    json = library.cloneObj(quickLinkData);
                } else {
                    let urlParams = location.search.substring(1).split('&');
                    let quicklink = decodeURI(urlParams.find((param) => param.indexOf('components=') === 0));
                    json = '{"' + quicklink
                        .replace(/%23/g, '#')
                        .replace(/"/g, '\\"')
                        .replace(/&/g, '","')
                        .replace(/===/g, '__::__')
                        .replace(/==/g, '__:__')
                        .replace(/=/g, '":"')
                        .replace(/__:__/g, '==')
                        .replace(/__::__/g, '===') + '"}';
                }
                if (library.isJson(json)) {
                    let searchObj = JSON.parse(json);
                    for (let i in searchObj) {
                        if (i.endsWith('Store') && typeof store[i] !== 'undefined') {
                            if (i === 'settingsEditorStore') {
                                if (searchObj['settingsEditorStore']['visibleEditorId']) store.dispatch('settingsEditorStore/getEditorFromCrc', searchObj['settingsEditorStore']['visibleEditorId'], { root: true });
                            } else {
                                for (let j in searchObj[i]) {
                                    store[i].state[j] = library.cloneObj(searchObj[i][j]);
                                }
                            }
                        }
                    }
                    if (quickLinkData) {
                        output = cId ? searchObj[cId] : searchObj;
                    } else {
                        if (searchObj.components) {
                            let compSettings = JSON.parse(searchObj.components);
                            output = compSettings[cId];
                        }
                    }
                }
            }
            return output;
        }
    },
    /* istanbul ignore next */
    timeout(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    },
    getUniqueID(mask, notUseDate) {
        if (!mask) mask = 'ssssssss'; // s = [0-9, a-z], n = [0-9]
        let d = new Date();
        let result = !notUseDate ? d.getTime().toString() : '';
        result += mask.replace(/[ns]/g, (c) => {
            // eslint-disable-next-line no-bitwise
            let r = Math.random() * (c === 'n' ? 10 : 16) | 0; // NOSONAR
            return r.toString(16); // NOSONAR
        });
        return result;
    },
    moveArrayItem(data, from, to) {
        // remove `from` item and store it
        data = library.cloneObj(data);
        let f = data.splice(from, 1)[0];
        // insert stored item into position `to`
        data.splice(to, 0, f);
        return data;
    },
    prependToArray(value, array) {
        let newArray = array.slice();
        newArray.unshift(value);
        return newArray;
    },
    arrayIncludesAll(arr, values) {
        if (!Array.isArray(arr) || !Array.isArray(values)) return false;
        return values.every((v) => arr.includes(v));
    },
    arrayIncludesAny(arr, values) {
        if (!Array.isArray(arr) || !Array.isArray(values)) return false;
        return values.some((v) => arr.includes(v));
    },
    unflatten(data) {
        // TODO possibly replace this with lodash
        if (Object(data) !== data || Array.isArray(data)) return data;
        let regex = /\.?([^.[\]]+)|\[(\d+)\]/g; // NOSONAR
        let resultholder = {};
        for (let p in data) {
            if (p === 'length') continue;
            let cur = resultholder;
            let prop = "";
            let m;
            // eslint-disable-next-line no-cond-assign
            while (m = regex.exec(p)) { // NOSONAR
                cur = cur[prop] || (cur[prop] = (m[2] ? [] : {})); // NOSONAR
                prop = m[2] || m[1]; // NOSONAR
            }
            cur[prop] = data[p];
        }
        return resultholder[""] || resultholder;
    },
    flatten(data, opt) {
        // TODO possibly replace this with lodash
        let result = {};
        function recurse(cur, prop, opt) { // NOSONAR
            let l;
            if (Object(cur) !== cur) {
                result[prop] = cur;
            } else if (Array.isArray(cur)) { // NOSONAR
                l = cur.length;
                for (let i = 0; i < l; i++) {
                    recurse(cur[i], prop + "[" + i + "]", opt);
                }
                /* istanbul ignore next */ if (l === 0) result[prop] = [];
            } else {
                let isEmpty = true;
                for (let iProp in cur) {
                    if (iProp === 'length') continue;
                    isEmpty = false;
                    if (opt && opt.objectAsArray) {
                        recurse(cur[iProp], prop ? prop + "[" + iProp + "]" : iProp, opt);
                    } else {
                        recurse(cur[iProp], prop ? prop + "." + iProp : iProp, opt);
                    }
                }
                if (isEmpty && prop) {
                    result[prop] = {};
                }
            }
        }
        recurse(data, "", opt);
        return result;
    },
    /* istanbul ignore next */
    async getQuickLink(openNewWindow, returnUrlObj, includedParams, domainUrl, jiraTicketUrl) {
        let componentParams = {};
        let getRealCid = (componentId) => {
            let outputcId = componentId;
            if (componentId.indexOf('__') !== -1) {
                let tmpcId = componentId.split('__');
                if (tmpcId.length && tmpcId[0].length) {
                    outputcId = tmpcId[0];
                }
            }
            return outputcId;
        };
        let encodeDataProps = (componentData, realcId, componentId, layoutId) => {
            for (let dataName in componentData) {
                if (dataName === 'length') continue;
                if (dataName === 'editorInitialized' || dataName === 'cInstanceId') return;
                if (includedParams && (!includedParams[realcId] || !includedParams[realcId][dataName])) continue;
                if (
                    !library.isEqualObj(store.state[layoutId][componentId][dataName], componentData[dataName])
                    && typeof store.state[layoutId][componentId][dataName] !== 'object'
                ) {
                    if (typeof componentParams[realcId] === 'undefined') componentParams[realcId] = {};
                    componentParams[realcId][dataName] = typeof store.state[layoutId][componentId][dataName] === "number" ? store.state[layoutId][componentId][dataName] : store.state[layoutId][componentId][dataName];
                }
            }
        };
        let encodeComponentControls = (componentId, layoutId) => {
            let excludedControlTypes = ['button', 'alert', 'dropdownbutton', 'textarea', 'text'];
            for (let si in store.state[layoutId][componentId].controls) {
                if (si === 'length') continue;
                let tmpControl = store.state[layoutId][componentId].controls[si];
                let controlName = tmpControl.name;
                if (includedParams && (!includedParams[componentId] || !includedParams[componentId][controlName])) continue;
                if (excludedControlTypes.indexOf(tmpControl.type) !== -1
                    || library.isEqualObj(tmpControl.initialValue, tmpControl.value)
                ) continue;
                let partialIndex = tmpControl.controlStoreIndex.split('/');
                partialIndex.shift(); // Remove storeId
                partialIndex.shift(); // Remove componentId
                partialIndex = partialIndex.join('/');
                if (typeof componentParams[componentId] === 'undefined') componentParams[componentId] = {};
                if (typeof componentParams[componentId]['controls'] === 'undefined') componentParams[componentId]['controls'] = {};
                let value = tmpControl.value;
                componentParams[componentId]['controls'][partialIndex] = value;
            }
        };
        let addStorePropsToUrl = (components, componentsData) => {
            for (let i in store.state) {
                if (i === 'length') continue;
                if (i.indexOf('layoutContainer') === -1 && i.indexOf('settingsEditor') === -1) continue;
                let layoutId = i;
                if (i.indexOf('settingsEditor') !== -1) {
                    if (i.indexOf('settingsEditorStore') !== -1) {
                        componentParams['settingsEditorStore'] = {
                            visibleEditorId: store.state['settingsEditorStore'].visibleEditorId
                        };
                    } else {
                        if (store.state[i]['openedPanel']) {
                            componentParams[i] = {
                                openedPanel: store.state[i]['openedPanel']
                            };
                        }
                    }
                } else {
                    for (let componentId in store.state[layoutId]) {
                        if (componentId === 'length') continue;
                        let realcId = getRealCid(componentId);
                        let componentType = components[realcId] ? components[realcId].cType : false;
                        let excludedComponents = ['labelWrapper', 'buildInfo'];
                        if (!componentType || excludedComponents.indexOf(componentType) !== -1) continue;
                        if (typeof componentsData[componentType] !== 'undefined') {
                            encodeDataProps(componentsData[componentType], realcId, componentId, layoutId);
                        }
                        encodeComponentControls(componentId, layoutId);
                    }
                }
            }
        };
        if (store && store.state && store.state.componentStore && store.state.componentStore.componentsConfig) {
            let componentsData = {};
            let components = componentStore.getComponents();
            for (let i in store.state.componentStore.componentsConfig) {
                if (i === 'length') continue;
                let component = library.cloneObj(store.state.componentStore.componentsConfig[i]);
                if (typeof component.data === 'function') {
                    componentsData[i] = component.data();
                }
            }
            addStorePropsToUrl(components, componentsData);
        }
        if (jiraTicketUrl) componentParams.jiraTicketUrl = jiraTicketUrl;
        if (returnUrlObj) return componentParams;
        let currentUrl = domainUrl || location.href;
        currentUrl = currentUrl.replace(/\?.*#\//g, '').replace('#/', ''); // NOSONAR
        // componentParams.accountId = 4444;
        let accountSettings = await configStore.getAccountSettings();
        componentParams.ACCOUNT_ID = accountSettings.ACCOUNT_ID;
        componentParams.ACCOUNT_ORG = accountSettings.ACCOUNT_ORG;
        let response = await sDs.post('sds_generateDevDashStateCrcLink', componentParams);
        let quickLinkCRC;
        let quickLink = '';
        if (response.status === 'success' && response.data) {
            quickLinkCRC = response.data;
            // let quickLink = currentUrl + '?components=' + JSON.stringify(componentParams);
            // Add a & after currentUrl if 'isProd', else add a ?
            const separator = currentUrl.includes('isprod') ? '&' : '?';
            quickLink = currentUrl + separator + 'quicklink=' + quickLinkCRC;
            quickLink = quickLink.replace(/(?:\r\n|\r|\n|\\n)/g, '');
            quickLink = quickLink.replace(/(#)/g, '%23');
            if (openNewWindow) window.open(quickLink);
        } else {
            library.showToast('Quick link not generated');
        }
        return quickLink;
    },
    /* istanbul ignore next */
    eval(code) {
        let res = false;
        try {
            // eslint-disable-next-line no-eval
            res = this && eval(code); // NOSONAR
        } catch (e) {
            res = false;
        }
        return res;
    },
    /* istanbul ignore next */
    getSessionStorage(itemName) {
        if (typeof IS_JEST !== 'undefined') return '';
        let v = customSessionStorage.getItem(itemName);
        return v == null ? "" : v;
    },
    /* istanbul ignore next */
    setSessionStorage(itemName, itemValue) {
        if (typeof IS_JEST !== 'undefined') return;
        customSessionStorage.setItem(itemName, itemValue);
    },
    /* istanbul ignore next */
    removeSessionStorage(itemName) {
        if (typeof IS_JEST !== 'undefined') return;
        customSessionStorage.removeItem(itemName);
    },
    /* istanbul ignore next */
    clearSessionStorage() {
        if (typeof IS_JEST !== 'undefined') return;
        customSessionStorage.clear();
    },
    /* istanbul ignore next */
    async clearAllCache() {
        libraryCaches = {};

        if (typeof caches !== 'undefined') {
            const configCache = await caches.open('config-cache');

            (await configCache.keys()).forEach((storeKey) => {
                if (!storeKey.url.includes('er_getLoggedUsers') && !storeKey.url.includes('er_login')) {
                    configCache.delete(storeKey);
                }
            });
        }
    },
    /* istanbul ignore next */
    async removeCache(storeKey, isMask = false) {
        if (typeof caches === 'undefined') {
            libraryCaches.removeItem(storeKey);
        } else {
            const configCache = await caches.open('config-cache');

            if (isMask) {
                (await configCache.keys()).forEach((configStoreKey) => {
                    if (configStoreKey.url.includes(storeKey)) {
                        configCache.delete(configStoreKey);
                    }
                });
            } else {
                await configCache.delete(storeKey);
            }
        }
    },
    /* istanbul ignore next */
    getLocalStorage(itemName) {
        if (typeof IS_JEST !== 'undefined') return '';
        let v = customLocalStorage.getItem(itemName);
        return v == null ? "" : v;
    },
    /* istanbul ignore next */
    setLocalStorage(itemName, itemValue) {
        if (typeof IS_JEST !== 'undefined') return;
        customLocalStorage.setItem(itemName, itemValue);
    },
    /* istanbul ignore next */
    removeLocalStorage(itemName) {
        if (typeof IS_JEST !== 'undefined') return;
        customLocalStorage.removeItem(itemName);
    },
    /* istanbul ignore next */
    clearLocalStorage() {
        if (typeof IS_JEST !== 'undefined') return;
        customLocalStorage.clear();
    },
    /* istanbul ignore next */
    getLastLocalSessionIds() {
        if (typeof IS_JEST !== 'undefined' || typeof FROM_LOCALHOST === 'undefined' || !FROM_LOCALHOST) return '';
        return library.getLocalStorage('lastLocalSessionIds');
    },
    /* istanbul ignore next */
    setLastLocalSessionIds() { /* store last 10 PHPSESSID */
        if (typeof IS_JEST !== 'undefined' || typeof FROM_LOCALHOST === 'undefined' || !FROM_LOCALHOST) return '';
        let sid = library.getSessionStorage('PHPSESSID');
        let lastLocalSessionIds = library.getLocalStorage('lastLocalSessionIds');
        lastLocalSessionIds = lastLocalSessionIds === '' ? [] : lastLocalSessionIds.split(',');
        if (lastLocalSessionIds.indexOf(sid) === -1) {
            if (lastLocalSessionIds.length >= 5) lastLocalSessionIds = lastLocalSessionIds.slice(1, lastLocalSessionIds.length);
            lastLocalSessionIds.push(sid);
        }
        if (lastLocalSessionIds.length) {
            library.setLocalStorage('lastLocalSessionIds', lastLocalSessionIds.join(','));
        }
        return sid;
    },
    /* istanbul ignore next */
    getLocalSessionId(forceIt) { /* for sDs work on localhost */
        if (typeof IS_JEST !== 'undefined') return '';
        if (typeof FROM_LOCALHOST !== 'undefined' && FROM_LOCALHOST) {
            let urlParams = new URLSearchParams(window.location.search);
            let forcedPhpSessId = urlParams.get('sid');
            if (forcedPhpSessId) library.setSessionStorage('PHPSESSID', forcedPhpSessId);
        }
        let sid = library.getSessionStorage('PHPSESSID');
        if (!sid || forceIt) {
            sid = library.getUniqueID('ssssssssssssssssssssssssssssssss', 1);
            library.setSessionStorage('PHPSESSID', sid);
        }
        library.setLastLocalSessionIds();
        return sid;
    },
    getMoment(dateString, dateFormat, isStrict) {
        let result;
        if (dateString && dateFormat && isStrict) {
            result = moment(dateString, dateFormat, isStrict);
        } else if (dateString && dateFormat) {
            result = moment(dateString, dateFormat);
        } else if (dateString) {
            result = moment(dateString);
        } else {
            result = moment();
        }
        return result;
    },
    getMomentObj() {
        return moment;
    },
    getTimeFormats() {
        return [
            "hh:mm a", "hh:m a", "h:mm a", "h:m a",
            "hh:mma", "hh:ma", "h:mma", "h:ma",
            "hh:mm A", "hh:m A", "h:mm A", "h:m A",
            "hh:mmA", "hh:mA", "h:mmA", "h:mA",
            "HH:mm", "H:mm", "HH:m", "H:m", "HH", "H",
            "h a", "ha", "h A", "hA",
        ];
    },
    getDateFormats() {
        return [
            moment.ISO_8601,
            moment.RFC_2822,
            "YYYY-MM-DD",
            "M/D/YYYY",
            "MM/DD/YYYY",
            'X',
            'MM/DD/YYYY h:mm A',
            'D MMM',
            'DD MMM YYYY hh:mm A',
            'D MMM YYYY'
        ];
    },
    getJsFormat(phpFormat, isDate) {
        let result;
        switch (phpFormat) {
            case 'j M Y':
                result = 'D MMM YYYY';
                break;
            case 'm/d/Y':
                result = 'MM/DD/YYYY';
                break;
            case 'g:i A':
                result = 'h:mm A';
                break;
            case 'G:i':
                result = 'H:mm';
                break;
        }
        if (!result) {
            result = isDate ? 'MM/DD/YYYY' : 'h:mm A';
        }
        return result;
    },
    parseRelativeDate(value) {
        if (typeof value === 'string' && value.indexOf('datePeriod') !== -1 && library.isJson(value)) {
            let dateJson = JSON.parse(value);
            value = library.getDateBaseOnPeriod(dateJson.datePeriod, dateJson.amount, false, dateJson.unit, dateJson.day);
        }
        return value;
    },
    toNumber(numStr, decimalCount) {
        let nOut = _.toNumber(numStr);
        return typeof decimalCount === 'number' ? nOut.toFixed(decimalCount) : nOut;
    },
    getDateBaseOnPeriod(datePeriod, defaultValue, operator, dateAdditionalParam, dateDay) {
        let value;
        let mDate;
        let unit;
        let unitOfTime;
        let accountSettings;
        let currentMonth;
        let startYear;
        let endYear;
        let fiscalMonth;
        let rangeFormat = 'YYYY-MM-DDTHH:mm:ss';
        switch (datePeriod) {
            case 81: // today before minus
                value = [];
                value[0] = '1900-01-01';
                value[1] = moment().add(-parseInt(defaultValue, 10), 'days').format('YYYY-MM-DD');
                break;
            case 82: // today after plus
                value = [];
                value[0] = moment().add(parseInt(defaultValue, 10), 'days').format('YYYY-MM-DD');
                value[1] = '2100-12-31';
                break;
            case 90: // Days Minus
                unit = 'days';
                if (dateAdditionalParam) unit = dateAdditionalParam;
                value = moment().add(-parseInt(defaultValue, 10), unit).format('YYYY-MM-DD');
                break;
            case 91: // Days Plus
                unit = 'days';
                if (dateAdditionalParam) unit = dateAdditionalParam;
                value = moment().add(parseInt(defaultValue, 10), unit).format('YYYY-MM-DD');
                break;
            case 92: // today through minus
                value = [];
                value[0] = moment().add(-parseInt(defaultValue, 10), 'days').format('YYYY-MM-DD');
                value[1] = moment().format('YYYY-MM-DD');
                break;
            case 93: // today through plus
                value = [];
                value[0] = moment().format('YYYY-MM-DD');
                value[1] = moment().add(parseInt(defaultValue, 10), 'days').format('YYYY-MM-DD');
                break;
            case 94: // Weeks Minus
                mDate = moment().add(-parseInt(defaultValue, 10), 'isoWeek');
                value = [];
                value[0] = mDate.startOf('isoWeek').format(rangeFormat);
                value[1] = mDate.endOf('isoWeek').format(rangeFormat);
                break;
            case 95: // Weeks Plus
                mDate = moment().add(parseInt(defaultValue, 10), 'isoWeek');
                value = [];
                value[0] = mDate.startOf('isoWeek').format(rangeFormat);
                value[1] = mDate.endOf('isoWeek').format(rangeFormat);
                break;
            case 96: // Month Minus
                mDate = moment().add(-parseInt(defaultValue, 10), 'months');
                value = [];
                value[0] = mDate.startOf('month').format(rangeFormat);
                value[1] = mDate.endOf('month').format(rangeFormat);
                break;
            case 97: // Month Plus
                mDate = moment().add(parseInt(defaultValue, 10), 'months');
                value = [];
                value[0] = mDate.startOf('month').format(rangeFormat);
                value[1] = mDate.endOf('month').format(rangeFormat);
                break;
            case 98: // Years Minus
                mDate = moment().add(-parseInt(defaultValue, 10), 'years');
                value = [];
                value[0] = mDate.startOf('years').format(rangeFormat);
                value[1] = mDate.endOf('years').format(rangeFormat);
                break;
            case 99: // Years Plus
                mDate = moment().add(parseInt(defaultValue, 10), 'years');
                value = [];
                value[0] = mDate.startOf('years').format(rangeFormat);
                value[1] = mDate.endOf('years').format(rangeFormat);
                break;
            case 101: // Yesterday
                value = moment().add(-1, 'days').format('YYYY-MM-DD');
                break;
            case 102: // Today
                value = moment().format('YYYY-MM-DD');
                break;
            case 103: // Tomorrow
                value = moment().add(1, 'days').format('YYYY-MM-DD');
                break;
            case 111: // Last Week
                value = [];
                mDate = moment().subtract(1, 'isoWeek');
                value[0] = mDate.startOf('isoWeek').format(rangeFormat);
                value[1] = mDate.endOf('isoWeek').format(rangeFormat);
                break;
            case 112: // This Week
                value = [];
                value[0] = moment().startOf('isoWeek').format(rangeFormat);
                value[1] = moment().endOf('isoWeek').format(rangeFormat);
                break;
            case 121: // Last Month
                value = [];
                mDate = moment().subtract(1, 'months');
                value[0] = mDate.startOf('month').format(rangeFormat);
                value[1] = mDate.endOf('month').format(rangeFormat);
                break;
            case 122: // This Month
                value = [];
                value[0] = moment().startOf('month').format(rangeFormat);
                value[1] = moment().endOf('month').format(rangeFormat);
                break;
            case 131: // Last Quarter
                value = [];
                mDate = moment().quarter(moment().subtract(1, 'quarters').quarter());
                value[0] = mDate.startOf('quarter').format(rangeFormat);
                value[1] = mDate.endOf('quarter').format(rangeFormat);
                break;
            case 132: // This Quarter
                value = [];
                mDate = moment().quarter(moment().quarter());
                value[0] = mDate.startOf('quarter').format(rangeFormat);
                value[1] = mDate.endOf('quarter').format(rangeFormat);
                break;
            case 141: // Last Year
                value = [];
                mDate = moment().subtract(1, 'years');
                value[0] = mDate.startOf('year').format(rangeFormat);
                value[1] = mDate.endOf('year').format(rangeFormat);
                break;
            case 142: // This Year
                value = [];
                value[0] = moment().startOf('year').format(rangeFormat);
                value[1] = moment().endOf('year').format(rangeFormat);
                break;
            case 144: // range ago
                unit = 'weeks';
                unitOfTime = 'isoWeek';
                switch (parseInt(dateAdditionalParam, 10)) {
                    case 0:
                        unit = 'weeks';
                        unitOfTime = 'isoWeek';
                        break;
                    case 1:
                        unit = 'months';
                        unitOfTime = 'month';
                        break;
                    case 2:
                        unit = 'years';
                        unitOfTime = 'year';
                        break;
                }
                mDate = moment().add(-parseInt(defaultValue, 10), unit);
                value = [];
                value[0] = mDate.startOf(unitOfTime).format(rangeFormat);
                value[1] = mDate.endOf(unitOfTime).format(rangeFormat);
                break;
            case 145: // range forward
                unit = 'isoWeek';
                unitOfTime = 'isoWeek';
                switch (parseInt(dateAdditionalParam, 10)) {
                    case 0:
                        unit = 'isoWeek';
                        unitOfTime = 'isoWeek';
                        break;
                    case 1:
                        unit = 'months';
                        unitOfTime = 'month';
                        break;
                    case 2:
                        unit = 'years';
                        unitOfTime = 'year';
                        break;
                }
                mDate = moment().add(parseInt(defaultValue, 10), unit);
                value = [];
                value[0] = mDate.startOf(unitOfTime).format(rangeFormat);
                value[1] = mDate.endOf(unitOfTime).format(rangeFormat);
                break;
            case 146: // first day of
                unit = 'isoWeek';
                unitOfTime = 'isoWeek';
                switch (dateAdditionalParam) {
                    case 'weeks':
                        unit = 'isoWeek';
                        unitOfTime = 'isoWeek';
                        break;
                    case 'months':
                        unit = 'months';
                        unitOfTime = 'month';
                        break;
                    case 'quarters':
                        unit = 'quarters';
                        unitOfTime = 'quarter';
                        break;
                    case 'years':
                        unit = 'years';
                        unitOfTime = 'year';
                        break;
                }
                mDate = moment().add((parseInt(defaultValue, 10) || 0), unit);
                value = mDate.startOf(unitOfTime).format('YYYY-MM-DD');
                break;
            case 147: // last day of
                unit = 'isoWeek';
                unitOfTime = 'isoWeek';
                switch (dateAdditionalParam) {
                    case 'weeks':
                        unit = 'isoWeek';
                        unitOfTime = 'isoWeek';
                        break;
                    case 'months':
                        unit = 'months';
                        unitOfTime = 'month';
                        break;
                    case 'quarters':
                        unit = 'quarters';
                        unitOfTime = 'quarter';
                        break;
                    case 'years':
                        unit = 'years';
                        unitOfTime = 'year';
                        break;
                }
                mDate = moment().add((parseInt(defaultValue, 10) || 0), unit);
                value = mDate.endOf(unitOfTime).format('YYYY-MM-DD');
                break;
            case 148: // day (number)
                value = moment().format('YYYY-' + (dateAdditionalParam < 10 ? '0' + dateAdditionalParam : dateAdditionalParam) + '-' + (dateDay < 10 ? '0' + dateDay : dateDay));
                break;
            case 149: // day (Mon-Sun)
                unit = 'isoWeek';
                unitOfTime = 'isoWeek';
                switch (dateAdditionalParam) {
                    case 'weeks':
                        unit = 'isoWeek';
                        unitOfTime = 'isoWeek';
                        break;
                }
                mDate = moment().add((parseInt(defaultValue, 10) || 0), unit);
                value = mDate.startOf(unitOfTime).add(dateDay, 'days').format('YYYY-MM-DD');
                break;
            case 150: // Last Fiscal Year
            case 151: // This Fiscal Year
            case 152: // Next Fiscal Year
                accountSettings = typeof configStore.state.cfg.accountSettings === 'object' ? configStore.state.cfg.accountSettings : { };
                currentMonth = moment().month() + 1;
                startYear = moment().year();
                endYear = startYear + 1;
                fiscalMonth = 1;
                value = [];
                if (
                    typeof accountSettings === 'object'
                    && typeof accountSettings.ACCOUNT_IS_INCLUDE_FISCAL_DATE !== 'undefined'
                    && typeof accountSettings.ACCOUNT_FIRST_MONTH_FISCAL_YEAR !== 'undefined'
                    && parseInt(accountSettings.ACCOUNT_IS_INCLUDE_FISCAL_DATE, 10) === 1
                ) {
                    fiscalMonth = parseInt(accountSettings.ACCOUNT_FIRST_MONTH_FISCAL_YEAR, 10);

                    if (!fiscalMonth || fiscalMonth < 1 || fiscalMonth > 12) {
                        fiscalMonth = 1;
                    }
                }
                if (fiscalMonth > currentMonth) {
                    startYear -= 1;
                    endYear -= 1;
                }
                if (datePeriod === 150) {
                    startYear -= 1;
                    endYear -= 1;
                } else if (datePeriod === 152) {
                    startYear += 1;
                    endYear += 1;
                }
                value[0] = moment({ year: startYear, month: fiscalMonth - 1, day: 1 }).format(rangeFormat);
                value[1] = moment({ year: endYear, month: fiscalMonth - 1, day: 1 }).subtract(1, 'second').format(rangeFormat);
                break;
            default:
                value = defaultValue;
                break;
        }
        // Adjust for operators that will only use one date from the range
        if (Array.isArray(value)) {
            if (operator === 'lessthan' || operator === 'greaterthanorequal') value = value[0];
            else if (operator === 'greaterthan' || operator === 'lessthanorequal') value = value[1];
        }
        return value;
    },
    convertDateToNumber(value) {
        let iFormat = 'x';
        if (typeof value === 'number') return value;
        if (value && typeof value === 'object' && typeof value.getTime === 'function') {
            return Math.floor(value.getTime());
        }
        if (typeof value !== 'string') return false;
        if (!isNaN(value)) return Number(value); // eg '1668705548834'
        value = value.replace(/ \d{1,}:\d{2} \w{2}$/, '').replace(/ \d{2}:\d{2}$/, ''); // Get just date
        let rgx1 = /^\d{2}\/\d{2}\/\d{4}$/; // MM/DD/YYYY
        if (rgx1.test(value)) {
            return Number(moment(value, 'MM/DD/YYYY').format(iFormat));
        }
        let rgx2 = /^\d{4}-\d{2}-\d{2}$/; // YYYY-MM-DD
        if (rgx2.test(value)) {
            return Number(moment(value, 'YYYY-MM-DD').format(iFormat));
        }
        let rgx3 = /^\d{4}\/\d{2}\/\d{2}$/; // YYYY/MM/DD
        if (rgx3.test(value)) {
            return Number(moment(value, 'YYYY/MM/DD').format(iFormat));
        }
        return Number(moment(value).format(iFormat));
    },
    convertTimeToNumber(time) {
        // Thu Sep 22 2022 14:47:50 GMT-0600
        // Thu Sep 22 2022T14:47:50 GMT-0600
        if (!time) return null;
        let h;
        let m;
        let a = 0;
        // Convert to Object
        if (typeof time === 'string' && (time.indexOf('T') > -1 || time.indexOf('Z') > -1)) {
            time = new Date(time);
        }
        if (typeof time === 'object' && typeof time.getDate === 'function') {
            h = time.getHours() * 60;
            m = time.getMinutes();
        }
        else if (time.indexOf(' ') > -1) {
            // 9:00 am
            let t = time.split(' ');
            a = t[1].toLowerCase();
            let u = t[0].split(':');
            h = Number(u[0]);
            m = Number(u[1]);
            h = (h === 12) ? 0 : h * 60; // convert hours to 0 if 12 am or 12 pm
            a = (a && a === 'pm') ? 720 : 0; // Add 12 hours for pm times
        }
        return h + m + a;
    },
    logicParser() {
        let start = performance.now();
        let logic;
        let object = [];
        let logicOptions = {};
        for (let i in arguments) {
            if (i === 'length') continue;
            let index = parseInt(i, 10);
            if (typeof arguments[i] === 'object' && arguments[i]?.logicOptions) {
                logicOptions = arguments[i]?.logicOptions;
                continue;
            }
            if (index === 0) {
                logic = library.cloneObj(arguments[i]);
            } else {
                object.push(arguments[i]);
            }
        }
        // Return the eval if the logic is a string
        if (typeof logic === 'string') {
            return library.eval.call(this, logic);
        }
        let cacheKey;
        if (library.optimization.enableLogicCache) {
            try {
                cacheKey = JSON.stringify(arguments);
            } catch (e) {
                // do nothing
            }
        }
        if (typeof logicCache?.[cacheKey] !== 'undefined') {
            return logicCache[cacheKey];
        }
        let parseDateRuleValue = (rule) => {
            if (rule.operator === 'amongdate') rule.operator = 'between';
            if (rule.operator === 'notamongdate') rule.operator = 'notbetween';
            // Handle units greater than one day
            if ((rule.value.datePeriod > 91 || rule.value.datePeriod === 81 || rule.value.datePeriod === 82) && rule.value.datePeriod !== 101 && rule.value.datePeriod !== 102) {
                if (rule.operator === 'notequal') rule.operator = 'notbetween';
                else if (rule.operator === 'equal' || typeof rule.operator === 'undefined') rule.operator = 'between';
            }
            let value;
            if (
                (
                    (rule.value.datePeriodFrom && rule.value.datePeriodTo)
                    || (rule.value.dateValueFrom && rule.value.dateValueTo)
                    || (rule.value.dateValueFrom && rule.value.datePeriodTo)
                    || (rule.value.datePeriodFrom && rule.value.dateValueTo)
                )
                && (rule.operator === 'between' || rule.operator === 'notbetween')
            ) {
                value = [];
                value[0] = library.getDateBaseOnPeriod(rule.value.datePeriodFrom, rule.value.dateValueFrom, rule.operator);
                value[1] = library.getDateBaseOnPeriod(rule.value.datePeriodTo, rule.value.dateValueTo, rule.operator);
            }
            else {
                value = library.getDateBaseOnPeriod(rule.value.datePeriod, rule.value.dateValue, rule.operator, rule.value.valueAdditionalParam);
            }
            rule.value = value;
            return rule;
        };

        let parseRule = (rule, logicRecord, fromWatcher) => {
            if (rule.criteriaRecord) {
                // eslint-disable-next-line no-use-before-define
                logicRecord = setRecord('criteriaRecord', rule, this, object);
            }
            if (!rule.field) return false;
            rule.field = rule.field.indexOf(':::') !== -1 ? rule.field.split(':::')[1] : rule.field;
            let iValue;
            let brLen = 2; // Min num of rules for "between" or "not between" logic
            let getPathVal = (field, iRecord) => {
                let iField;
                if (!iRecord) iRecord = logicRecord;
                if (field.indexOf('.') === -1) iField = '["' + field + '"]';
                else iField = field.indexOf('this.') === -1 ? field : field.replace('this.', '');
                if (iField.indexOf('$store') === 0 || iField.indexOf('component.currentInstance') === 0) return library.getByPath(this, iField);
                if (iField.indexOf('Store Prop:') !== -1) {
                    iField = iField.replace('Store Prop:', '');
                    let storeName = this.parentStore || this.storeName || this.parentStoreId;
                    return library.getByPath(this.$store.state[storeName], iField);
                }
                let pathVal = library.getByPath(iRecord, iField);
                return library.cloneObj(pathVal);
            };
            let parseRelativeCompare = (val) => {
                if (!library.isJson(val)) return false;
                val = val.replace(/vol:::|opp:::|org:::|sch:::|lbe:::|aff:::/g, ''); // TODO make this better, maybe connect it to parseLogictoFront?
                // val = val.indexOf(':::') !== -1 ? val.split(':::')[1] : rule.field;
                let valJson = JSON.parse(val);
                let val1;
                let val2;
                if (Array.isArray(valJson.value1)) valJson.value1 = valJson.value1[0];
                if (Array.isArray(valJson.value2)) valJson.value2 = valJson.value2[0];
                const contextFields = ['volId', 'oppId', 'orgId', 'affId', 'schId', 'lbeId', 'aeId', 'entryPointId'];
                const iRecord1 = contextFields.indexOf(valJson.value1) !== -1 ? this : logicRecord;
                const iRecord2 = contextFields.indexOf(valJson.value2) !== -1 ? this : logicRecord;
                val1 = getPathVal(valJson.value1, iRecord1);
                val2 = getPathVal(valJson.value2, iRecord2);
                return {
                    val1,
                    val2,
                };
            };
            const parseAffiliation = (val) => {
                let { operator, field } = rule;
                if (!val || !library.isJson(val)) return false;
                let valObj = JSON.parse(val);
                let compareRecords = {
                    vol: false,
                    opp: false
                };
                let getSourceRecord = (srcVal, vKey) => {
                    // eg: context_vol, context_opp, source_vol, source_opp, fixed_vol, fixed_opp
                    // Sets compareRecords
                    // Uses logicRecord in some cases
                    // Uses recordStore from provided component as this
                    if (!srcVal || typeof srcVal !== 'string' || !this.recordStore) return;
                    let [type, psp] = srcVal.split('_');
                    let records = this.recordStore.records;
                    if (type === 'context') compareRecords[psp] = records[psp][this[psp + 'Id']]; // volId, oppId, orgId
                    else if (type === 'source' && logicRecord && logicRecord.rowID) compareRecords[psp] = records[psp][logicRecord.rowID];
                    else if (type === 'fixed' && valObj[vKey + 'fixedId']) compareRecords[psp] = records[psp][valObj[vKey + 'fixedId']];
                };
                getSourceRecord(valObj.value1, 'value1');
                getSourceRecord(valObj.value2, 'value2');
                let recordKey;
                let compareRecordId;
                let recordIds;
                let status = valObj.status;
                let primaryRecord;
                if (field === 'Affiliation') {
                    recordKey = 'affIds';
                    primaryRecord = compareRecords.vol || compareRecords.org;
                    recordIds = primaryRecord && Object.values(primaryRecord[recordKey]); // list of org or vol IDs
                    compareRecordId = compareRecords.org && compareRecords.org.uiRecordId;
                }
                else {
                    recordKey = operator.indexOf('refer') !== -1 ? 'referredIds' : 'placedIds';
                    primaryRecord = compareRecords.vol || compareRecords.opp;
                    recordIds = primaryRecord && Object.values(primaryRecord[recordKey]);
                    compareRecordId = compareRecords.opp && compareRecords.opp.uiRecordId;
                }
                let relatedIdIndex = compareRecordId ? recordIds.indexOf(compareRecordId) : -1;
                // Return result
                let isRelated = (operator === 'placed' && relatedIdIndex !== -1)
                    || (operator === 'referred' && relatedIdIndex !== -1)
                    || (operator.indexOf('any') !== -1 && recordIds.length)
                    || (operator.indexOf('empty') !== -1 && !recordIds.length)
                    || (operator.indexOf('not') === -1 && relatedIdIndex !== -1)
                    || (operator.indexOf('not') !== -1 && relatedIdIndex === -1);
                if (status && status !== 'any_status' && isRelated) {
                    let affId = Object.keys(primaryRecord[recordKey])[relatedIdIndex];
                    let affRecord = this.recordStore.records.aff[affId];
                    return affRecord.AFF_STATUS.toLowerCase() === status.toLowerCase();
                }
                return isRelated;
            };
            if (typeof rule?.operator?.endsWith === 'function' && rule.operator.endsWith('_array')) {
                rule.operator = rule.operator.replace('_array', '');
                rule.type = 'array';
            }
            // Get value
            let recordPsp = rule.psp;
            if (recordPsp === 'waiver' || recordPsp === 'training') recordPsp = 'lbe';
            let ruleField = rule.field.indexOf(':::') !== -1 ? rule.field.split(':::')[1] : rule.field;
            if (ruleField === 'ACC_CURRENT_DATE') {
                iValue = configStore.state.cfg.currentDate || new Date();
            } else if (rule.type === 'relativeCriteria' || rule.type === 'refPlace' || rule.type === 'affiliation') {
                iValue = rule.value;
            }
            else if (recordPsp && rule.criteriaRecord === 'dynamically' && typeof configStore.pspParentNames[recordPsp] !== 'undefined') {
                let recordId = (typeof rule.recordId !== 'undefined' && rule.recordId) || this[recordPsp + 'Id'];
                if (!recordId && recordPsp === 'acc' && this.accountSettings.ACCOUNT_ID > 0) recordId = this.accountSettings.ACCOUNT_ID;
                if (recordId) {
                    let source = recordPsp === 'lbe' || recordPsp === 'assignment'
                        ? ['sds_getProfileField']
                        : ['er_' + recordPsp + 'Fields'];
                    // TODO can't we just use sds_getProfileField now?
                    let fields = [ruleField];
                    let params = {
                        recordId,
                        fields,
                        recordPsp,
                        updateFrequency: 60
                    };
                    let logicSub = this.recordStore.subscribe({ source, params }, this.cId);
                    let collectAs = logicOptions.collectAs || 'componentPendingSubscriptions';
                    if (logicSub.initialLoading && this[collectAs].indexOf(logicSub.key) === -1) {
                        if (!logicOptions.doNotAddToPendingSubscriptions) this[collectAs] = [...this[collectAs], ...[logicSub.key]];
                        let stopWatch = this.$watch('recordStore.subscriptions.' + logicSub.key + '.initialLoading', (subLoading) => {
                            if (!subLoading) {
                                // waiting initial load and stop watching
                                stopWatch();
                                let tmpComponentPendingSubscriptions = library.cloneObj(this[collectAs]);
                                const subIndex = tmpComponentPendingSubscriptions.indexOf(logicSub.key);
                                if (subIndex > -1) {
                                    tmpComponentPendingSubscriptions.splice(subIndex, 1); // 2nd parameter means remove one item only
                                }
                                this[collectAs] = library.cloneObj(tmpComponentPendingSubscriptions);
                            }
                        });
                    }
                    let pathToRecord = 'recordStore.records.' + recordPsp + '.' + recordId + '.' + rule.field;
                    if (!fromWatcher && logicFieldWatchers.indexOf(pathToRecord) === -1) {
                        logicFieldWatchers.push(pathToRecord);
                        this.$watch(pathToRecord, (newValue, oldValue) => {
                            // For some reason oldValue === newValue in this watcher, this causes extra calls to logicParser
                            // console.log(oldValue === newValue); /* @phpstan-ignore-line */
                            if (oldValue !== newValue) library.logicParser.apply(this, arguments, true /* fromWatcher */);
                        }, { deep: true });
                    }
                    iValue = this?.recordStore?.records?.[recordPsp]?.[recordId]?.[ruleField];
                } else {
                    // Return a blank record for !== logic on a record that doesn't exist
                    iValue = getPathVal(ruleField);
                }
            } else iValue = getPathVal(rule.field);
            // Activity Status field adjustments
            if (rule.field === 'VOL_ACTIVITY_STATUS') {
                if (iValue) iValue = iValue.toLowerCase();
            }
            // Date adjustments
            let dateRuleVal;
            let dateVal = iValue;
            let timeRuleVal;
            if (rule.type === 'date') {
                let getDateVal = library.convertDateToNumber;
                // change the iValue to ms since epoch
                iValue = getDateVal(iValue);
                if (rule.value && library.isJson(rule.value)) {
                    rule.value = JSON.parse(rule.value);
                    rule = parseDateRuleValue(rule);
                }
                // change rule values to ms since epoch
                if (Array.isArray(rule.value)) {
                    dateRuleVal = rule.value.map((val) => getDateVal(val));
                }
                else dateRuleVal = getDateVal(rule.value);
            }
            else if (rule.type === 'time') {
                iValue = library.convertTimeToNumber(iValue);
                timeRuleVal = library.convertTimeToNumber(rule.value);
            }
            else if (rule.type === 'string') {
                if (Array.isArray(rule.value)) {
                    for (let i in rule.value) {
                        if (i === 'length') continue;
                        rule.value[i] = typeof rule.value[i] === 'string' ? rule.value[i].toLowerCase() : rule.value[i];
                    }
                } else {
                    rule.value = typeof rule.value === 'string' ? rule.value.toLowerCase() : rule.value;
                }
                if (Array.isArray(iValue)) iValue = iValue[0];
                iValue = typeof iValue === 'string' ? iValue.toLowerCase() : iValue;
            } else if (rule.type === 'array') {
                if (!Array.isArray(iValue)) iValue = [iValue];
                for (let tmpI in iValue) {
                    // typeof null = object
                    if (typeof iValue[tmpI] === 'object' && iValue[tmpI] !== null) {
                        // TODO Standardize this
                        if (iValue[tmpI]?.value) iValue[tmpI] = iValue[tmpI].value;
                        else if (iValue[tmpI]?.ACTIVITY_ENTITY_ID) iValue[tmpI] = iValue[tmpI].ACTIVITY_ENTITY_ID;
                    }
                    else iValue[tmpI] += '';
                }
            }
            // Operator functions
            let type = rule.type === 'number' ? 'numeric' : rule.type;
            let relVals = type === 'relativeCriteria' && parseRelativeCompare(iValue);
            let operators = {
                'isnotempty': {
                    'date': (val) => !!library.isDate(dateVal),
                    'string': (val) => !!val,
                    'text': (val) => !!val,
                    'numeric': (val) => !isNaN(val) && val !== null,
                    'boolean': (val) => val === true || val === false || val === 0 || val === 1 || val === '0' || val === '1',
                    'array': (val) => Array.isArray(val) && val.length > 0,
                    'affiliation': (val) => parseAffiliation(val)
                },
                'isempty': {
                    'date': (val) => !library.isDate(dateVal),
                    'string': (val) => !val,
                    'text': (val) => !val,
                    'numeric': (val) => !val && val !== 0,
                    'boolean': (val) => !val && val !== false && val !== 0,
                    'array': (val) => !Array.isArray(val) || val.length === 0,
                    'affiliation': (val) => parseAffiliation(val)
                },
                'startswith': {
                    'string': (val) => !!rule.value && typeof val === 'string' && val.startsWith(rule.value),
                    'text': (val) => !!rule.value && typeof val === 'string' && val.startsWith(rule.value)
                },
                'endswith': {
                    'string': (val) => !!rule.value && typeof val === 'string' && val.endsWith(rule.value),
                    'text': (val) => !!rule.value && typeof val === 'string' && val.endsWith(rule.value)
                },
                'contains': {
                    'string': (val) => !!rule.value && typeof val === 'string' && val.includes(rule.value),
                    'relativeCriteria': () => relVals && relVals.val1 && relVals.val2 && relVals.val1.includes(relVals.val2),
                    'text': (val) => !!rule.value && typeof val === 'string' && val.includes(rule.value)
                },
                'notcontains': {
                    'string': (val) => !!rule.value && typeof val === 'string' && !val.includes(rule.value),
                    'relativeCriteria': () => relVals && relVals.val1 && relVals.val2 && !relVals.val1.includes(relVals.val2),
                    'text': (val) => !!rule.value && typeof val === 'string' && !val.includes(rule.value)
                },
                'equal': {
                    'date': (val) => library.isDate(dateVal) && val === dateRuleVal,
                    'time': (val) => typeof timeRuleVal === 'number' && typeof val === 'number' && val === timeRuleVal,
                    'string': (val) => typeof val === 'string' && val === rule.value,
                    'text': (val) => typeof val === 'string' && val === rule.value,
                    'numeric': (val) => !isNaN(val) && val === rule.value,
                    'boolean': (val) => (val === true || val === false || val === 0 || val === 1 || val === '0' || val === '1') && val === rule.value,
                    'relativeCriteria': () => relVals && relVals.val1 === relVals.val2,
                    'array': (val) => library.isEqualObj(val, rule.value)
                },
                'notequal': { // NOTE: if val is undefined this should return true (also for cases when there is no record)
                    'date': (val) => library.isDate(dateVal) && val !== dateRuleVal,
                    'time': (val) => val !== timeRuleVal, // Values are numbers eg 300 !== 400
                    'string': (val) => val !== rule.value,
                    'text': (val) => val !== rule.value,
                    'numeric': (val) => !isNaN(val) && val !== rule.value,
                    'relativeCriteria': () => relVals && relVals.val1 !== relVals.val2,
                    'boolean': (val) => val !== rule.value
                },
                'greaterthan': {
                    'date': (val) => library.isDate(dateVal) && library.isDate(rule.value) && val > dateRuleVal,
                    'time': (val) => typeof timeRuleVal === 'number' && typeof val === 'number' && val > timeRuleVal,
                    'numeric': (val) => !isNaN(val) && !isNaN(rule.value) && val > rule.value
                },
                'greaterthanorequal': {
                    'date': (val) => library.isDate(dateVal) && library.isDate(rule.value) && val >= dateRuleVal,
                    'time': (val) => typeof timeRuleVal === 'number' && typeof val === 'number' && val >= timeRuleVal,
                    'numeric': (val) => !isNaN(val) && !isNaN(rule.value) && val >= rule.value
                },
                'lessthan': {
                    'date': (val) => library.isDate(dateVal) && library.isDate(rule.value) && val < dateRuleVal,
                    'time': (val) => typeof timeRuleVal === 'number' && typeof val === 'number' && val < timeRuleVal,
                    'numeric': (val) => !isNaN(val) && !isNaN(rule.value) && val < rule.value
                },
                'lessthanorequal': {
                    'date': (val) => library.isDate(dateVal) && library.isDate(rule.value) && val <= dateRuleVal,
                    'time': (val) => typeof timeRuleVal === 'number' && typeof val === 'number' && val <= timeRuleVal,
                    'numeric': (val) => !isNaN(val) && !isNaN(rule.value) && val <= rule.value
                },
                'amongdate': {
                    'date': (val) => Array.isArray(rule.value) && rule.value.length === brLen && library.isDate(dateVal) && library.isDate(rule.value[0]) && library.isDate(rule.value[1]) && val >= dateRuleVal[0] && val <= dateRuleVal[1],
                },
                'notamongdate': {
                    'date': (val) => Array.isArray(rule.value) && rule.value.length === brLen && library.isDate(dateVal) && library.isDate(rule.value[0]) && library.isDate(rule.value[1]) && !(val >= dateRuleVal[0] && val <= dateRuleVal[1]),
                },
                'between': {
                    'date': (val) => Array.isArray(rule.value) && rule.value.length === brLen && library.isDate(dateVal) && library.isDate(rule.value[0]) && library.isDate(rule.value[1]) && val >= dateRuleVal[0] && val <= dateRuleVal[1],
                    'numeric': (val) => Array.isArray(rule.value) && rule.value.length === brLen && !isNaN(val) && !isNaN(rule.value[0]) && !isNaN(rule.value[1]) && val >= rule.value[0] && val <= rule.value[1],
                },
                'notbetween': {
                    'date': (val) => Array.isArray(rule.value) && rule.value.length === brLen && library.isDate(dateVal) && library.isDate(rule.value[0]) && library.isDate(rule.value[1]) && !(val >= dateRuleVal[0] && val <= dateRuleVal[1]),
                    'numeric': (val) => Array.isArray(rule.value) && rule.value.length === brLen && !isNaN(val) && !isNaN(rule.value[0]) && !isNaN(rule.value[1]) && !(val >= rule.value[0] && val <= rule.value[1]),
                },
                'in': {
                    'string': (val) => Array.isArray(rule.value) && rule.value.length && rule.value.indexOf(val.toLowerCase()) !== -1,
                    'text': (val) => Array.isArray(rule.value) && rule.value.length && rule.value.indexOf(val.toLowerCase()) !== -1,
                    'numeric': (val) => Array.isArray(rule.value) && rule.value.length && !isNaN(val) && rule.value.indexOf(val) !== -1,
                    'array': (val) => Array.isArray(val) && val.indexOf(rule.value) !== -1,
                    'affiliation': (val) => parseAffiliation(val),
                    'relativeCriteria': () => relVals && Array.isArray(relVals.val1) && typeof relVals.val2 !== 'undefined' && relVals.val2 !== null && relVals.val1.indexOf(relVals.val2) > -1
                },
                'notin': {
                    'string': (val) => Array.isArray(rule.value) && rule.value.length && rule.value.indexOf(val.toLowerCase()) === -1,
                    'text': (val) => Array.isArray(rule.value) && rule.value.length && rule.value.indexOf(val.toLowerCase()) === -1,
                    'numeric': (val) => Array.isArray(rule.value) && rule.value.length && !isNaN(val) && rule.value.indexOf(val) === -1,
                    'array': (val) => !Array.isArray(val) || val.indexOf(rule.value) === -1,
                    'affiliation': (val) => parseAffiliation(val),
                    'relativeCriteria': () => !relVals || !Array.isArray(relVals.val1) || typeof relVals.val2 !== 'undefined' || relVals.val2 !== null || relVals.val1.indexOf(relVals.val2) === -1
                },
                referred: {
                    refPlace: (val) => parseAffiliation(val),
                },
                notreferred: {
                    refPlace: (val) => parseAffiliation(val),
                },
                isemptyreferred: {
                    refPlace: (val) => parseAffiliation(val),
                },
                isanyreferred: {
                    refPlace: (val) => parseAffiliation(val),
                },
                placed: {
                    refPlace: (val) => parseAffiliation(val),
                },
                notplaced: {
                    refPlace: (val) => parseAffiliation(val),
                },
                isemptyplaced: {
                    refPlace: (val) => parseAffiliation(val),
                },
                isanyplaced: {
                    refPlace: (val) => parseAffiliation(val),
                }
            };
            // Convert array type operator values to array of not already
            /* if (rule.value && (rule.operator === 'in' || rule.operator === 'notin' || rule.operator === 'amongdate' || rule.operator === 'notamongdate' || rule.operator === 'between' || rule.operator === 'notbetween')) {
                if (!Array.isArray(rule.value)) rule.value = [rule.value];
            } */
            // Adjust type = number to type = numeric for old logic
            if (!operators[rule.operator] || !operators[rule.operator][type]) {
                // errorHandler.error
                return false;
            }
            if (rule.field === 'VOL_REFERENCES' && typeof iValue === 'string') {
                // exception for VOL_REFERENCES
                let excValue = parseInt(iValue, 10);
                if (!isNaN(excValue)) iValue = excValue;
            }
            return operators[rule.operator][type](iValue);
        };

        let setLogicString = (criteria, logicRecord) => {
            let output = '';
            if (typeof criteria === 'string') output = criteria;
            else if (!criteria.rules || !criteria.rules.length) output = 'false';
            else {
                if (criteria.rules.length > 1) output += "( ";
                criteria.rules.forEach((rule, index) => {
                    let condition = '';
                    if (index > 0) {
                        condition = criteria.condition === 'and' ? ' && ' : ' || ';
                    }
                    if (typeof rule.rules === 'undefined') {
                        output += condition + parseRule(rule, logicRecord);
                    } else {
                        output += condition + setLogicString(rule, logicRecord);
                    }
                });
                if (criteria.rules.length > 1) output += " )";
            }
            return output;
        };

        let setRecord = function (recordType, logicItem, pThis, pObject) {
            let output;
            let type;
            let path;
            type = logicItem[recordType] || 'component';
            // set the base output object
            if (type.indexOf('component') === 0) output = pThis;
            else {
                // Handle self and object recordTypes
                let index = 0;
                if (type.indexOf('object') === 0) {
                    index = type.match(/\d+/);
                    index = index && index[0];
                    index = Number(index);
                    if (index > 0) index--;
                }
                output = pObject[index];
            }
            // parse additional dot notation pathing
            if (type.indexOf('.') !== -1) {
                path = type.replace('component.', '')
                    .replace('self.', '');
                pObject.forEach((arg, index) => {
                    path = path.replace('object' + index + '.', '');
                });
            }
            if (path) output = library.getByPath(output, path);
            return output;
        };

        let getOutputValue = (logicItem, logicResult, pObject) => {
            let output = logicResult; // Default to logicResult value
            if (logicItem.valueType !== 'criteria') {
                if (logicResult === true) {
                    switch (logicItem.valueType) {
                        case 'value':
                            output = logicItem.value;
                            break;
                        case 'control':
                            output = this.controls && this.controls[logicItem.valueControl] ? this.controls[logicItem.valueControl].value : null;
                            break;
                        case 'path':
                            output = library.getByPath(pObject, logicItem.valuePath);
                            break;
                        case 'user':
                            if (Array.isArray(logicItem.valueUserSetting)) {
                                let path = logicItem.valueUserSetting[0].replace('this.', '');
                                output = library.getByPath(this, path);
                            }
                            break;
                        case 'account':
                            if (Array.isArray(logicItem.valueAccountSetting)) {
                                let path = logicItem.valueAccountSetting[0].replace('this.', '');
                                output = library.getByPath(this, path);
                            }
                            break;
                    }
                }
                else {
                    // If logicResult is false set output to undefined to end logic parsing
                    output = undefined; // NOSONAR - Null is a valid output and cannot be used here
                }
            }
            return output;
        };

        // if (object.realId === 'someString') debugger;
        let returnedResult;
        // called from component to goes through all config
        if (!logic && !object.length && this.cType) {
            let componentsConfig = componentStore.get('componentsConfig');
            if (componentsConfig[this.cType]) {
                let editorSettings = library.flatten(componentsConfig[this.cType].editorSettings);
                _.forOwn(editorSettings, (value, key) => {
                    if (key.endsWith('cType') && value === 'logicEditor') {
                        let logicKey = key.replace('.cType', '');
                        let pathKey = key.replace('.' + logicKey + '.cType', '');
                        let newObject = _.get(this, pathKey);
                        library.logicParser.call(this, library.getByPath(this, logicKey), newObject || this);
                        library.logicParser.call(this, library.getByPath(this.config, logicKey), newObject || this);
                    } else if (key.endsWith('type') && value === 'logicEditor') {
                        let logicKey = key.replace('.type', '');
                        let pathKey = key.replace('.' + logicKey + '.type', '');
                        let newObject = _.get(this, pathKey);
                        library.logicParser.call(this, library.getByPath(this, logicKey), newObject || this);
                        library.logicParser.call(this, library.getByPath(this.config, logicKey), newObject || this);
                    }
                });
            }
        } else {
            // set up values base on passed logic
            for (let i in logic) {
                if (i === 'length') continue;
                // Temp fix because devDash was not displaying
                if (logic[i].criteria && typeof logic[i].criteria.replaceAll !== 'undefined') {
                    logic[i].criteria = logic[i].criteria.replaceAll(' AND ', '&&');
                    logic[i].criteria = logic[i].criteria.replaceAll(' OR ', '||');
                    logic[i].criteria = logic[i].criteria.replaceAll("'false'", 'false');
                }
                // Get the record
                let logicRecord = setRecord('criteriaRecord', logic[i], this, object);
                // Get the eval String
                let logicString = setLogicString(logic[i].criteria, logicRecord);
                // Run the eval and get the logic result
                let logicResult = library.eval.call(logicRecord, logicString);
                // Set the returnedResult
                if (logic[i].resultType === 'returnCriteria') {
                    if (typeof returnedResult === 'undefined') returnedResult = true; // NOSONAR
                    if (returnedResult) returnedResult = logicResult; // NOSONAR
                    continue;
                }
                // Get value record
                let valueRecord = setRecord('valueRecord', logic[i], this, object);
                // Modify the value
                let value = getOutputValue(logic[i], logicResult, valueRecord);
                // Don't set the property if the value is undefined
                if (logic[i].valueType !== 'criteria' && typeof value === 'undefined') continue;
                // Set the property
                if (!logic[i].prop) continue;
                if (logic[i].prop && logic[i].prop.indexOf('storeProps.') !== -1) {
                    let property = logic[i].prop.replace('storeProps.', '');
                    // if (logic[i].valueType === 'value') value = logic[i].value;
                    this.$store.state[this.layoutStoreName][property] = value;
                }
                else {
                    let saveTo = logic[i].record === 'component' ? this : object[0];
                    if (saveTo && !library.isEqualObj(value, library.getByPath(saveTo, logic[i].prop)) && typeof value !== 'undefined') {
                        library.setByPath(saveTo, logic[i].prop, value);
                    }
                }
            }
        }
        let result = typeof returnedResult !== 'undefined' ? returnedResult : object[0];
        if (cacheKey) logicCache[cacheKey] = result;
        if (library.optimization.log.logic) {
            // eslint-disable-next-line no-console
            console.log('logic', logic, performance.now() - start);
        }
        logicOptions?.onCalculateHandler?.(result);
        return result;
    },
    getRealIndexes(indexPathStr, pThis, itemIndexArray, doNotCheckIndexArrayLength) {
        if (typeof indexPathStr !== 'string') return false;
        // function getIndexesFromParentChain() {
        //     let p = pThis.$parent;
        //     let indexes = [];
        //     while (!p.isComponent) {
        //         if (typeof p.index !== 'undefined') {
        //             indexes.push(p.index);
        //         }
        //         p = p.$parent;
        //     }
        //     indexes.reverse();
        // }
        let replaceIndex = (path) => {
            if (!path.includes('__index__') || !itemIndexArray?.length) return path;

            // TODO possibly remove this and just use itemIndexArray
            // NOTE: Function is commented out to see if it is still needed.
            // if (!itemIndexArray) {
            //     getIndexesFromParentChain();
            //     return path;
            // }

            const placeholderCount = (path.match(/__index__/g) || []).length;

            if (placeholderCount === itemIndexArray?.length || doNotCheckIndexArrayLength) {
                itemIndexArray.forEach((index) => {
                    path = path.replace('__index__', index);
                });
            } else {
                // Note: this is a quick fix for DEVD-1969 and may come with more issue
                path = path.replace('__index__', itemIndexArray.at(-1));
            }

            return path;
        };

        // Split string by || and && but keep the operators in the array [a,||,b,&&,c]
        const tokens = indexPathStr
            .split(/\s*(\|\||&&)\s*/)
            .filter(Boolean);

        return tokens
            .map(replaceIndex)
            .join(' ');
    },
    getLogicPropsToWatch(logic, objMap) {
        let output = [];
        let checkLogicString = (iLogic) => {
            let iOutput = [];
            if (typeof iLogic === 'string') {
                iLogic = iLogic
                    .replace(/this\./g, '')
                    .replace(/\[/g, '.')
                    .replace(/]/g, '')
                    .replace(/!/g, '')
                    .replace(/\n/g, '')
                    .split('||')
                    .join(',')
                    .split('&&')
                    .join(',')
                    .split(',');
                if (Array.isArray(iLogic)) {
                    iLogic.forEach((iiLogic) => {
                        iOutput.push(iiLogic.replace(/ /g, '').split('=')[0]);
                    });
                    return iOutput.length && iOutput;
                }
            }
            return false;
        };
        if (Array.isArray(logic)) {
            logic.forEach((logicItem) => {
                let criteria;
                let crType = typeof logicItem.criteria;
                if (crType === 'string') criteria = checkLogicString(logicItem.criteria);
                else if (crType === 'object' && Array.isArray(logicItem.criteria.rules)) {
                    let objName = objMap[logicItem.criteriaRecord];
                    logicItem.criteria.rules.forEach((rule) => {
                        if (rule.field) {
                            if (!criteria) criteria = [];
                            if (objName) criteria.push(objName + '.' + rule.field);
                            else criteria.push(rule.field);
                        }
                    });
                }
                if (criteria) output = output.concat(criteria);
                if (logicItem.valueType === 'path') {
                    let valuePath = checkLogicString(logicItem.valuePath);
                    if (valuePath) output = output.concat(valuePath);
                } else if (logicItem.valueType === 'control' && logicItem.valueControl) {
                    output.push('controls.' + logicItem.valueControl + '.value');
                }
            });
        } else {
            output = checkLogicString(logic);
        }
        return output.length && output;
    },
    getFromParents(_this, matchKeys, returnValue, maxDepth) {
        // maxDepth is the number of parents deep we go
        // matchKey is an object of key/value pairs to determine a matching parent
        // returnValue returns specific key on the parent otherwise returns whole parent object
        if (!maxDepth) maxDepth = 30;
        let parent = _this;
        let parentValue;
        for (let i = 0; i < maxDepth; i++) { // NOSONAR
            if (!parent) break;
            // iterate key/values
            let isMatch = true;
            // eslint-disable-next-line no-loop-func,consistent-return
            _.forOwn(matchKeys, function (value, key) {
                if (!isMatch) return false; // Exit on any non-match
                isMatch = (value === '!!' && !!parent[key]) // not falsy
                    || (value === '!' && !parent[key]) // not truthy
                    || (value !== '!' && value !== '!!' && value.indexOf('!') === 0 && parent[key] !== value) // not equal
                    || parent[key] === value; // exact match
            });
            if (isMatch) {
                // return the value if returnValue is set
                if (parent && parent[returnValue]) parentValue = parent[returnValue];
                break;
            }
            parent = parent.$parent;
        }
        return parentValue || parent;
    },
    getByPath(object, path, defaultVal) {
        return _.get(object, path, defaultVal); // _.get() comes from lodash library
    },
    setByPath(object, path, value) {
        return _.set(object, path, value); // _.set() comes from lodash library
    },
    /**
     * Recursively searches an object for a specified key
     * and returns either the first match or all matches, including their paths and values.
     *
     * @param {Object} obj - The object or array you want to search.
     * @param {string} key - The prop, or key, you want to find.
     * @param {boolean} findAll - Search entire object and return all instances of the property (default to false).
     *
     * @returns {{ path: string, value: any } | Array<{ path: string, value: any }> | null}
     */
    findPathAndValue(obj, key, findAll = false) {
        if (!obj) return null;

        const results = [];
        function helper(current, path) {
            if (!_.isObject(current)) return false;
            for (const _key in current) {
                if (!Object.prototype.hasOwnProperty.call(current, _key)) continue; // prevent error if object created without prototype
                const newPath = Array.isArray(current) // update path array
                    ? [...path, `[${_key}]`]
                    : [...path, _key];
                if (_key === key) {
                    results.push({
                        path: newPath.join('.').replace(/\.\[(\d+)\]/g, '[$1]'), // Convert path array to string path value
                        value: current[_key]
                    });
                    if (!findAll) return true; // Break out if !findAll
                }
                const shouldStop = helper(current[_key], newPath);
                if (shouldStop && !findAll) return true; // Bubble out if !findAll
            }
            return false;
        }

        helper(obj, []);

        if (findAll) {
            return results.length > 0 ? results : null;
        }
        return results[0] || null;
    },
    pullAll(array, values) {
        return _.pullAll(array, values);
    },
    getFunctionParams(func) {
        // String representaation of the function code
        let str = typeof func === 'string' ? func : func.toString();

        // Remove comments of the form /* ... */
        // Removing comments of the form //
        // Remove body of the function { ... }
        // removing '=>' if func is arrow function
        str = str.replace(/\/\*[\s\S]*?\*\//g, '')
            .replace(/\/\/(.)*/g, '')
            .replace(/{[\s\S]*}/, '')
            .replace(/=>/g, '')
            .trim();

        // Start parameter names after first '('
        let start = str.indexOf("(") + 1;

        // End parameter names is just before last ')'
        let end = str.length - 1;

        let result = str.substring(start, end).split(", ");

        let params = [];

        result.forEach((element) => {
            // Removing any default value
            element = element.replace(/=[\s\S]*/g, '').trim();

            if (element.length > 0) params.push(element);
        });

        return params;
    },
    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    },
    /* istanbul ignore next */
    getBrowser() {
        let res = {};
        // Opera 8.0+
        res.isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
        // Firefox 1.0+
        res.isFirefox = typeof InstallTrigger !== 'undefined';
        // Safari 3.0+ "[object HTMLElementConstructor]"
        res.isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
            return p.toString() === "[object SafariRemoteNotification]";
        }(!window['safari'] || safari.pushNotification));
        // Internet Explorer 6-11
        res.isIE = /* @cc_on!@ */false || !!document.documentMode;
        // Edge 20+
        res.isEdge = !res.isIE && !!window.StyleMedia;
        // Chrome 1+
        res.isChrome = !!window.chrome;
        // Blink engine detection
        res.isBlink = (res.isChrome || res.isOpera) && !!window.CSS;
        return res;
    },
    getBrowserName: /* istanbul ignore next */ function () {
        let res = browser();
        return res.name;
    },
    isMobile: /* istanbul ignore next */ function () {
        if (typeof IS_JEST !== 'undefined') return false;
        let res = browser();
        return res.mobile;
    },
    arrayUnique(value, index, self) {
        return self.indexOf(value) === index;
    },
    /* istanbul ignore next */
    getPspName(psp) {
        let pspNames = {
            '1': 'Volunteer',
            '2': 'Opportunity',
            '3': 'Organization',
            '4': 'Campaign',
            '5': 'Client',
            '6': 'Approver',
            '7': 'Reference',
            '10': 'Log Book',
            '11': 'Schedule Shift',
            '14': 'Profession',
            '100': 'Account',
            '101': 'eC User'
        };
        return pspNames[psp] || pspNames[psp + ''] || '';
    },
    /* istanbul ignore next */
    getPspByAbbrev(abbrev) {
        abbrev = abbrev?.toLowerCase?.();
        return configStore.pspIds[abbrev] || false;
    },
    /* istanbul ignore next */
    geolocation: {
        lat: null,
        lng: null,
        browserWithGeo: false,
        watchLocation: false,
        funcOnSuccess: /* istanbul ignore next */ function () {}, // NOSONAR
        funcOnFail: /* istanbul ignore next */ function () {}, // NOSONAR
        getDistanceFromLatLonInM: /* istanbul ignore next */ function (lat1, lon1, lat2, lon2) {
            let R = 6371; // NOSONAR
            let dLat = library.geolocation.deg2rad(lat2 - lat1); // deg2rad below
            let dLon = library.geolocation.deg2rad(lon2 - lon1);
            let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) // NOSONAR
                + Math.cos(library.geolocation.deg2rad(lat1)) * Math.cos(library.geolocation.deg2rad(lat2))
                * Math.sin(dLon / 2) * Math.sin(dLon / 2); // NOSONAR
            let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)); // NOSONAR
            let d = R * c * 1000; // NOSONAR
            return d;
        },
        deg2rad: /* istanbul ignore next */ function (deg) {
            return deg * (Math.PI / 180); // NOSONAR
        },
        getLocationLatLng: /* istanbul ignore next */ function (position) {
            library.geolocation.lat = position.coords.latitude;
            library.geolocation.lng = position.coords.longitude;
            library.geolocation.browserWithGeo = true;
            if (typeof library.geolocation.funcOnSuccess === 'function') library.geolocation.funcOnSuccess(position.coords.latitude, position.coords.longitude);
        },
        getLocationLatLngFromWatch: /* istanbul ignore next */ function (position) {
            library.geolocation.lat = position.coords.latitude;
            library.geolocation.lng = position.coords.longitude;
            library.geolocation.browserWithGeo = true;
            if (typeof library.geolocation.funcOnSuccess === 'function') library.geolocation.funcOnSuccess(position.coords.latitude, position.coords.longitude, true);
        },
        getLocationError: function () {
            library.geolocation.browserWithGeo = false;
            if (typeof library.geolocation.funcOnFail === 'function') library.geolocation.funcOnFail(false, false);
        },
        getLocation: function () {
            if (navigator.geolocation && (location.protocol === 'https:' || location.href.indexOf('http://localhost') === 0)) { // NOSONAR
                try {
                    navigator.geolocation.getCurrentPosition(this.getLocationLatLng, this.getLocationError);
                } catch (e) {
                    library.geolocation.browserWithGeo = false;
                }
                try {
                    if (library.geolocation.watchLocation) {
                        setInterval(() => {
                            navigator.geolocation.getCurrentPosition(this.getLocationLatLngFromWatch, this.getLocationError);
                        }, 5000);
                    }
                    // eslint-disable-next-line no-empty
                } catch (e) {}
            } else {
                library.geolocation.browserWithGeo = false;
            }
        }
    },
    /* istanbul ignore next */
    fileToBase64(inputFile) {
        const temporaryFileReader = new FileReader();

        return new Promise((resolve, reject) => {
            temporaryFileReader.onerror = () => {
                temporaryFileReader.abort();
                reject(new DOMException("Problem parsing input file."));
            };

            temporaryFileReader.onload = () => {
                resolve(temporaryFileReader.result);
            };
            temporaryFileReader.readAsDataURL(inputFile);
        });
    },
    interpolateVueVariables(inputStr, objName, obj) {
        let d = { [objName]: obj };
        let re = /{{(.*?)}}/mg; // NOSONAR
        let variablesPaths = inputStr.matchAll(re);
        for (const match of variablesPaths) {
            if (match[1]) {
                let key = match[1].replace(objName + '.', '');
                let value = library.getByPath(d[objName], key);
                inputStr = inputStr.replace(match[0], value || '');
            }
        }
        return inputStr;
    },
    /* istanbul ignore next */
    downloadURI(url, name) {
        let obj = {};
        obj.link = document.createElement("a");
        if (!name) name = url.substring(url.lastIndexOf('/') + 1);
        obj.link.download = name;
        obj.link.href = url;
        obj.link.target = '_blank';
        document.body.appendChild(obj.link);
        obj.link.click();
        document.body.removeChild(obj.link);
        delete obj.link;
    },
    /* istanbul ignore next */
    fileContentToBase64(content) {
        let base64 = '';
        try {
            base64 = btoa(content);
        } catch (e) {
            return base64;
        }
        return base64;
    },
    /* istanbul ignore next */
    base64ToFileContent(content) {
        let base64 = '';
        try {
            base64 = atob(content);
        } catch (e) {
            return base64;
        }
        return base64;
    },
    /* istanbul ignore next */
    createTemplateComponent(templateId, tmpObject, _this) {
        if (typeof IS_JEST !== 'undefined') return '';
        if (_this) {
            let thisParams = ['storeId', 'tmpStoreId', 'dataTestId'];
            if (typeof tmpObject.props === 'undefined') tmpObject.props = {};
            for (let i in thisParams) {
                if (i === 'length') continue;
                let name = thisParams[i];
                if (typeof _this[name] !== 'undefined') {
                    tmpObject.props[name] = {
                        default: _this[name]
                    };
                }
            }
            tmpObject.props['isPopupTemplate'] = {
                default: true
            };
            tmpObject.props['component'] = {
                default: _this
            };
        }
        if (tmpObject.template) {
            tmpObject.template = '<div v-if="!parentUnmounted">' + tmpObject.template + '</div>';
            if (typeof tmpObject.computed === 'undefined') tmpObject.computed = {};
            tmpObject.computed['parentUnmounted'] = function () {
                return this && this.component ? this.component.componentUnmounted : false;
            };
            tmpObject.computed['fromDynamicTemplate'] = function () {
                return true;
            };
        }
        if (tmpObject.useTemplateComponentMixins) {
            delete tmpObject.useTemplateComponentMixins;
            tmpObject.mixins = [];
            tmpObject.mixins.push(componentStore.getComponentMixins({ useTemplateComponentMixins: true }));
        }
        let tmpCmp = vueApp.component(templateId, tmpObject);
        let tmpFunc = function () {
            return {
                template: tmpCmp
            };
        };
        Object.defineProperty(tmpFunc, "name", { value: templateId });
        return tmpFunc;
    },
    /* istanbul ignore next */
    isWrappedHTML(str) {
        let a = document.createElement('div');
        a.innerHTML = str;
        if (a.childNodes && a.childNodes[0] && a.childNodes[0].nodeType === 1) return true;
        return false;
    },
    /* istanbul ignore next */
    isHTML(str) {
        let a = document.createElement('div');
        a.innerHTML = str;
        for (let c = a.childNodes, i = c.length; i--;) {
            if (c[i].nodeType === 1) return true;
        }
        return false;
    },
    /* istanbul ignore next */
    escapeHtmlChars(str) {
        if (typeof str !== 'string') return str;
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;'
        };
        return str.replace(/[&<>"']/g, (char) => map[char]);
    },
    removeInvisibleCharacters(input) {
        let output = "";
        if (typeof input !== 'string') return input;
        for (let i = 0; i < input.length; i++) {
            // eslint-disable-next-line no-mixed-operators
            if (input.charCodeAt(i) <= 127 || input.charCodeAt(i) >= 160 && input.charCodeAt(i) <= 255) {
                output += input.charAt(i);
            }
        }
        return output;
    },
    removeInterpolatedAttributes(html) {
        let a = document.createElement('div');
        a.innerHTML = html;
        let tmpElements = a.getElementsByTagName('*');
        for (let i in tmpElements) {
            let tmpElAttributes = typeof tmpElements[i].getAttributeNames === 'function' ? tmpElements[i].getAttributeNames() : [];
            for (let j in tmpElAttributes) {
                let currAttrName = tmpElAttributes[j];
                if (currAttrName.startsWith(':')) {
                    let newAttrName = currAttrName.substring(1);
                    html = html.replaceAll(currAttrName, newAttrName);
                }
            }
        }
        return html;
    },
    /* istanbul ignore next */
    validateHTML(html, controlRef) {
        if (typeof html !== 'string') return { valid: true };
        let htmlValidator = library.getHtmlValidator(true);
        let htmlWithoutInterpolation = html
            .replaceAll(/{{(.+?)}}/gmi, 'interpolation')
            .replaceAll('v-bind', '');
        htmlWithoutInterpolation = library.removeInterpolatedAttributes(htmlWithoutInterpolation);
        if (htmlWithoutInterpolation.indexOf('{{') !== -1 || htmlWithoutInterpolation.indexOf('}}') !== -1) {
            return {
                valid: false,
                results: [
                    {
                        messages: [
                            {
                                message: 'Interpolation has no {{ or }}'
                            }
                        ]
                    }
                ]
            };
        }
        let res = htmlValidator.validateStringSync(htmlWithoutInterpolation, controlRef);
        if (res.valid) {
            let interpolationItems = [...html.matchAll(/{{(.+?)}}/gmi)];
            if (interpolationItems.length) {
                for (let interpolationString of interpolationItems) {
                    interpolationString = interpolationString[1];
                    if (library.isHTML(interpolationString)) {
                        // check that interpolationString without html
                        res.valid = false;
                        break;
                    }
                }
            }
        }
        /* if (res.valid) {
            let matches = html.match(/{{(.*)}}/);
            if (matches) {
                for (const match of matches) {
                    const interpolation = match.slice(2, -2).trim();
                    const isRecordAccess = interpolation.includes('.')
                        || interpolation === 'record'
                        || interpolation.includes(`record["`)
                        || interpolation.includes(`record['`);

                    if (!isRecordAccess) {
                        const vForPattern = new RegExp(`v-for=['"]\\(?${interpolation}`, 'g');
                        if (!vForPattern.test(html)) {
                            res.valid = false;
                        }
                        break;
                    }
                }
            }
        } */
        return res;
    },
    trimHTML(str) {
        if (!library.isHTML(str)) return str;
        let a = document.createElement('div');
        a.innerHTML = str;
        return a.textContent;
    },
    getDefaultJSMethods() {
        if (!defaultJSMethods.length) {
            try {
                let stringPrototype = Object.getOwnPropertyNames(String.prototype);
                for (let i in stringPrototype) {
                    if (stringPrototype[i] === 'constructor') continue;
                    if (typeof String.prototype[stringPrototype[i]] === 'function') {
                        defaultJSMethods.push(stringPrototype[i]);
                    }
                }
                let arrayPrototype = Object.getOwnPropertyNames(Array.prototype);
                for (let i in arrayPrototype) {
                    if (arrayPrototype[i] === 'constructor') continue;
                    if (typeof String.prototype[arrayPrototype[i]] === 'function') {
                        defaultJSMethods.push(arrayPrototype[i]);
                    }
                }
            } catch (e) {
                // do nothing
            }
        }
        return defaultJSMethods;
    },
    tryToFixTemplate(htmlString) {
        let invalidTemplate = "<div>(Invalid Template)</div>";
        if (typeof htmlString !== 'string') return invalidTemplate;
        let matches = [...htmlString.matchAll(/{{(.+?)}}/gmi)];
        if (matches && matches.length) {
            // add optional chaining to the objects between {{}}
            // {{records.org[record.assignment.LINKED_RECORDS['200'].ID]['CA#Settings/Volunteer_Coordinator'][0]}}
            // changed to
            // {{records?.org?.[record?.assignment?.LINKED_RECORDS?.['200']?.ID]?.['CA#Settings/Volunteer_Coordinator']}}
            for (let match of matches) {
                if (!match[1]) continue;
                let replaceString = match[1];
                let replaceWithString = replaceString;
                replaceWithString = replaceWithString.replaceAll('===', 'eq__,__eq__,__eq'); // do not change order with eq__,__eq
                replaceWithString = replaceWithString.replaceAll('==', 'eq__,__eq'); // do not change order with eq__,__eq__,__eq
                if (replaceWithString?.indexOf('=') !== -1) continue; // do not check if contains =, a?.a = 1 cause "Invalid left-hand side in assignmentUnderstand this error"
                if (replaceWithString?.indexOf('.') !== -1 && replaceWithString?.indexOf('...') === -1) {
                    replaceWithString = replaceWithString.replace(/(?<!\?)[.]/gm, '?.');
                }
                if (replaceWithString?.indexOf('[') !== -1) {
                    replaceWithString = replaceWithString.replace(/(?<!\?\.)(?<=\w|\])[[]/gm, '?.[');
                }
                replaceWithString = replaceWithString.replaceAll('eq__,__eq__,__eq', '==='); // do not change order with eq__,__eq
                replaceWithString = replaceWithString.replaceAll('eq__,__eq', '=='); // do not change order with eq__,__eq__,__eq
                htmlString = htmlString.replace('{{' + replaceString + '}}', '{{' + replaceWithString + '}}');
            }
        }
        let tmpEl = document.createElement('div');
        tmpEl.innerHTML = htmlString.trim();
        let innerElements = tmpEl?.firstChild?.querySelectorAll?.('*') || false;
        if (innerElements) {
            // add optional chaining to the dynamic attributes (starts with : or v- or @)
            // v-if="records.org[record.assignment.LINKED_RECORDS['200'].ID]['CA#Settings/Volunteer_Coordinator'][0]"
            // changed to
            // v-if="records?.org?.[record?.assignment?.LINKED_RECORDS?.['200']?.ID]?.['CA#Settings/Volunteer_Coordinator']"
            let innerElementsWithAttributes = Object.values(innerElements).filter((tmpInnerEl) => tmpInnerEl?.attributes?.length);
            if (innerElementsWithAttributes) {
                for (let i in innerElementsWithAttributes) {
                    for (let j in innerElementsWithAttributes[i].attributes) {
                        if (!innerElementsWithAttributes[i].attributes.hasOwnProperty(j)) continue;
                        let attribute = innerElementsWithAttributes[i].attributes[j];
                        let attributeName = attribute.name;
                        let isVueAttribute = attributeName.startsWith(':') || attributeName.startsWith('v-') || attributeName.startsWith('@');
                        if (!isVueAttribute) continue; // check only dynamic attributes
                        if (attributeName.startsWith('v-model') || attributeName.startsWith('v-html')) continue; // do not change v-model
                        let replaceString = attribute?.value || '';
                        let replaceWithString = replaceString;
                        replaceWithString = replaceWithString.replaceAll('===', 'eq__,__eq__,__eq'); // do not change order with eq__,__eq
                        replaceWithString = replaceWithString.replaceAll('==', 'eq__,__eq'); // do not change order with eq__,__eq__,__eq
                        if (replaceWithString?.indexOf('=') !== -1) continue; // do not check if contains =, a?.a = 1 cause "Invalid left-hand side in assignmentUnderstand this error"
                        if (replaceWithString?.indexOf('.') !== -1 && replaceWithString?.indexOf('...') === -1) {
                            replaceWithString = replaceWithString.replace(/(?<!\?)[.]/gm, '?.');
                        }
                        if (replaceWithString?.indexOf('[') !== -1) {
                            replaceWithString = replaceWithString.replace(/(?<!\?\.)(?<=\w|\])[[]/gm, '?.[');
                        }
                        replaceWithString = replaceWithString.replaceAll('eq__,__eq__,__eq', '==='); // do not change order with eq__,__eq
                        replaceWithString = replaceWithString.replaceAll('eq__,__eq', '=='); // do not change order with eq__,__eq__,__eq
                        if (replaceString && replaceWithString) htmlString = htmlString.replaceAll('"' + replaceString + '"', '"' + replaceWithString + '"');
                    }
                }
            }
        }
        let tmpDefaultJSMethods = library.getDefaultJSMethods();
        // add optional chaining to the default js methods
        // 'string'.split(' ')
        // chandeg to
        // 'string'.split?.(' ')
        for (let i in tmpDefaultJSMethods) {
            htmlString = htmlString.replaceAll('.' + tmpDefaultJSMethods[i] + '(', '.' + tmpDefaultJSMethods[i] + '?.(');
        }
        return htmlString;
    },
    getHtmlValidator(isStrict) {
        // https://html-validate.org/rules/index.html
        let htmlValidatorRules = {
            rules: {
                "no-inline-style": ["off"],
                "close-order": ["error"],
                "no-implicit-close": ["error"],
            }
        };
        if (isStrict) {
            htmlValidatorRules = {
                rules: {
                    "no-inline-style": ["off"],
                    "close-order": ["error"],
                    "no-implicit-close": ["error"],
                    "element-name": ["off"],
                    "element-permitted-content": ["off"],
                    "no-dup-attr": ["off"],
                    "no-dup-class": ["off"],
                    "attribute-allowed-values": ["off"],
                    "no-unused-disable": ["off"],
                    "prefer-tbody": ["off"],
                    "prefer-button": ["off"],
                    "no-trailing-whitespace": ["off"],
                    "no-self-closing": ["off"],
                    "element-case": ["off"],
                    "attribute-empty-style": ["off"],
                    "attribute-boolean-style": ["off"],
                    "element-permitted-parent": ["off"],
                    "empty-heading": ["off"],
                    "void-style": ["off"],
                    "attr-quotes": ["off"]
                },
                extends: ['html-validate:recommended']
            };
        }
        let loader = new StaticConfigLoader(htmlValidatorRules);
        return new HtmlValidate(loader);
    },
    checkTemplate(htmlString, name, isStrict) {
        let htmlValidator = library.getHtmlValidator(isStrict);
        let invalidTemplate = "<div>(Invalid Template)</div>";
        let preparedTemplate = htmlString;
        if (typeof htmlString !== 'string') {
            preparedTemplate = invalidTemplate;
        } else {
            htmlString = library.tryToFixTemplate(htmlString);
            let vObj = htmlValidator.validateStringSync(htmlString);
            if (!vObj?.valid) {
                if (typeof errorHandler?.handle === 'function') {
                    let errorStr = '';
                    let errors = [];
                    if (Array.isArray(vObj?.results?.[0]?.messages)) {
                        for (let i in vObj.results[0].messages) {
                            errors.push(vObj.results[0].messages[i].message);
                        }
                    }
                    if (errors.length) errorStr = errors.join('\n');
                    errorHandler.handle("Template error!!! Caused in '" + name + "' component\nTemplate error(s):" + errorStr + "\nTemplate:\n" + htmlString);
                }
                preparedTemplate = htmlString; // @todo change to invalidTemplate, when invalidTemplate component will be ready
            } else {
                preparedTemplate = htmlString;
            }
        }
        return preparedTemplate;
    },
    /* istanbul ignore next */
    checkEmail(value) {
        if (value) {
            value = value.trim();
            let re = /^(([^<>()[\]\\,;:\s@]+(\.[^<>()[\],;:\s@']+)*))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(value)) {
                return false;
            }
        }
        return true;
    },
    /* istanbul ignore next */
    checkPhone(value, mask) {
        if (value && mask) {
            let escapedMask = mask.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            let pattern = '^' + escapedMask.replace(/#/g, '\\d') + '$';
            return new RegExp(pattern).test(value);
        }
        return true;
    },
    /* istanbul ignore next */
    removeDoubleSpaces(str) {
        if (typeof str === 'string') {
            let tmpStrArray = str.split(' ');
            let tmpStr = '';
            for (let i in tmpStrArray) {
                if (i === 'length') continue;
                if (tmpStrArray[i].trim()) {
                    tmpStr += (i > 0 ? ' ' : '') + tmpStrArray[i].trim();
                }
            }
            str = tmpStr;
        }
        return str;
    },
    /* istanbul ignore next */
    async promiseAllSettled(promises) {
        for (let i in promises) {
            if (i === 'length') continue;
            if (typeof promises[i].catch === 'function') {
                promises[i].catch((e) => {
                    throw e;
                });
            }
        }
        let result = [];
        if (typeof Promise.allSettled === 'function') {
            result = await Promise.allSettled(promises);
        } else {
            for (let i = 0; i < promises.length; i++) {
                // eslint-disable-next-line no-await-in-loop
                let tmpRes = await promises[i];
                result[i] = {
                    status: "fulfilled",
                    value: tmpRes,
                };
            }
        }
        return result;
    },
    /* istanbul ignore next */
    isFromLocalhost() {
        return typeof FROM_LOCALHOST !== 'undefined' ? FROM_LOCALHOST : false;
    },
    /* istanbul ignore next */
    isPointInsideRectangle(point, rect) {
        return point.x > rect.left && point.x < rect.right && point.y > rect.top && point.y < rect.bottom;
    },
    /* istanbul ignore next */
    arrayMove(arr, fromIndex, toIndex) {
        let element = arr[fromIndex];
        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);
        return arr;
    },
    recordSourceMapper(source, srcParams, mappedRecord, component, includeComponent) {
        if (!srcParams || typeof srcParams !== 'object') return false;
        srcParams = library.cloneObj(srcParams);
        let recordSourceKeys = Object.keys(srcParams).filter((param) => param.indexOf('recordSource') === 0);
        recordSourceKeys.forEach((sourceKey) => {
            let srcType = srcParams[sourceKey];
            let typeIsContext = srcType?.indexOf('context') === 0;
            let typeIsSource = srcType === 'source';
            let typeIsSubSource = srcType === 'subSource';
            let typeIsStoreProp = srcType === 'storeProp';
            let outputKey = sourceKey.split('recordSource_')[1] || 'recordId';
            if (!typeIsSource && !typeIsContext && !typeIsSubSource && !typeIsStoreProp) return;
            // let matchingFields = 'lbeId'; // find possible record IDs
            let paramSettings;
            // eslint-disable-next-line no-nested-ternary
            let sourceOption = typeof source === 'object'
                ? source
                : (typeof actionStore?.state?.actionOptions !== 'undefined' ? actionStore.state.actionOptions.find((option) => option.value === source) : false);
            if (sourceOption) paramSettings = sourceOption.params.find((param) => (param.value === sourceKey || param.id === sourceKey));
            let pspParamFields = actionStore?.state?.pspParamFields;
            let matchingFields;
            if (typeIsSource || typeIsSubSource) {
                // Check action for dynamic perspective based list of fields
                let pspSrcFields = paramSettings
                    && paramSettings.pspParamForMatchingFields
                    && srcParams[paramSettings.pspParamForMatchingFields]
                    && pspParamFields[srcParams[paramSettings.pspParamForMatchingFields]];
                if (pspSrcFields) {
                    matchingFields = pspSrcFields;
                }
                else {
                    matchingFields = paramSettings && paramSettings.matchingFields
                        ? paramSettings.matchingFields
                        : ['rowID'];
                }
            } else {
                matchingFields = [library.lowerFirstLetter(srcType.replace('context', ''))];
            }
            let srcRecord;
            // Get the subSourcePath property from the config might be 'subSource' or 'someOtherField_subSource'
            let subSourcePath = srcParams.subSourcePath;
            if (!subSourcePath) subSourcePath = srcParams[outputKey + '_subSourcePath'];
            if (typeIsContext) srcRecord = component;
            else if (typeIsSource) srcRecord = mappedRecord;
            else if (typeIsStoreProp) {
                const layoutId = component.parentStoreId;
                const storeProperty = srcParams[Object.keys(srcParams).find((key) => key.includes('storeProp'))];
                const storePropValue = store.state?.[layoutId]?.[storeProperty];
                srcRecord = storePropValue ? store.state?.[layoutId]?.[storeProperty] : false;
            } else if (typeIsSubSource) {
                if (subSourcePath.indexOf('this.') === 0) subSourcePath = subSourcePath.replace('this.', '');
                if (subSourcePath.indexOf('component.') === 0) {
                    srcRecord = library.getByPath(component, subSourcePath.replace('component.', ''));
                }
                else {
                    srcRecord = library.getByPath(mappedRecord, subSourcePath);
                }
            }
            if (typeof srcRecord !== 'object' || Array.isArray(srcRecord)) {
                srcParams[outputKey] = srcRecord;
            } else {
                matchingFields.some((field) => {
                    let hasField = typeof srcRecord[field] !== 'undefined';
                    if (hasField) {
                        srcParams[outputKey] = srcRecord[field];
                    }
                    return hasField;
                });
            }
            // remove param recordSource_whatever
            delete srcParams[sourceKey];
        });
        srcParams.mappedRecord = mappedRecord;
        // Note: including component in computed properties causes recursive recalculation
        if (includeComponent) {
            srcParams.component = {};
            for (let i in component) {
                // DO NOT INCLUDE STORES, causes recursive recalculation
                if (i !== '_' && !i.endsWith('Store') && !i.endsWith('Settings')) {
                    try {
                        srcParams.component[i] = component[i];
                    } catch (e) {
                        // do nothing
                    }
                }
            }
        }
        return srcParams;
    },
    async cachedTransaction(method, storeKey, data) {
        let cacheOutput = false;
        let cacheResponse = false;
        if (typeof caches === 'undefined') {
            return new Promise((resolve) => {
                if (method === 'put') {
                    libraryCaches[storeKey] = data;
                    resolve({
                        status: 'success',
                        fromCaching: true
                    });
                } else if (method === 'get') {
                    let tmpData = false;
                    let tmpStatus = 'failure';
                    if (typeof libraryCaches[storeKey] !== 'undefined') {
                        tmpData = JSON.parse(libraryCaches[storeKey]);
                        tmpStatus = 'success';
                    }
                    resolve({
                        status: tmpStatus,
                        fromCaching: true,
                        data: tmpData
                    });
                }
            });
        }
        const configCache = await caches.open('config-cache');
        if (method === 'put') {
            const options = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            cacheResponse = new Response(data, options);
            cacheOutput = await configCache.put(storeKey, cacheResponse);
        }
        else if (method === 'get') {
            cacheResponse = await configCache.match(storeKey);
            if (cacheResponse) cacheOutput = await cacheResponse.json();
        }
        return new Promise(
            function (resolve) {
                let status = cacheResponse && cacheResponse.status === 200 ? 'success' : 'failure'; // NOSONAR
                if (method === 'get') {
                    resolve({
                        status,
                        fromCaching: true,
                        data: cacheOutput
                    });
                } else if (method === 'put') {
                    resolve({
                        status,
                        fromCaching: true
                    });
                }
            }
        );
    },
    escapeRegExp(text) {
        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    },
    getRulesString: function (rules, queryStr) {
        // copy of QueryBuilder.prototype.getSqlFromRules
        let isRoot = false;
        if (!queryStr && queryStr !== '') {
            queryStr = '';
            isRoot = true;
        }
        else {
            queryStr += ' ( ';
        }
        let condition = rules.condition || 'and';
        if (rules.rules) {
            for (let j = 0, jLen = rules.rules.length; j < jLen; j++) {
                if (rules.rules[j].rules) {
                    queryStr = library.getRulesString(rules.rules[j], queryStr);
                    if (this.enableSeparateConnector) {
                        condition = rules.rules[j].condition;
                    }
                }
                else {
                    let rule = rules.rules[j];
                    queryStr += ' __field__ ';
                    if (rule.condition && rule.condition !== '') {
                        condition = rule.condition;
                    }
                }
                if (j !== jLen - 1) {
                    let rule = rules.rules[j];
                    if (condition === '' || (rule && rule.condition !== '' && rule.custom && rule.custom.isCustom)) {
                        condition = rule.condition;
                    }
                    if (condition) {
                        condition = condition.toUpperCase();
                        queryStr += ' ' + condition + ' ';
                    }
                }
            }
        }
        if (!isRoot) {
            queryStr += ' ) ';
        }
        return queryStr;
    },
    parseLogicToBackend(logicObject, forPsp) {
        let logicOperators = configStore.state.cfg.logicOperatorsList;
        let pspList = configStore.state.cfg.pspList;
        if (!library.objIsEmpty(pspList)) pspList = Object.values(pspList);
        let result = {};
        if (Array.isArray(logicObject.rules) && logicObject.rules.length) {
            let flattenLogicObject = library.flatten(logicObject);
            result['[FilterEditor::FiltersColumns]'] = [];
            let realPerspective = "ACTIVITY_ENTITY";
            if (forPsp) {
                let tmpPspObj = pspList.find((tmpPsp) => (tmpPsp.abbrev.toUpperCase() === forPsp.toUpperCase()));
                if (!library.objIsEmpty(tmpPspObj)) {
                    realPerspective = tmpPspObj.name;
                }
            }
            for (let i in flattenLogicObject) {
                if (i.endsWith('.field') && flattenLogicObject[i] === '__field__') {
                    let tmpRulesPath = i.replace(/(\[\d+\].field$)/, '');
                    let tmpRules = library.getByPath(logicObject, tmpRulesPath);
                    if (Array.isArray(tmpRules)) {
                        tmpRules = tmpRules.filter((tmp) => tmp.field !== '__field__');
                        library.setByPath(logicObject, tmpRulesPath, tmpRules);
                    }
                }
            }
            for (let i in flattenLogicObject) {
                if (i.endsWith('.field')) {
                    let tmpRulePath = i.replace(/(.field$)/, '');
                    let tmpRule = library.getByPath(logicObject, tmpRulePath);
                    if (tmpRule && !library.objIsEmpty(tmpRule)) {
                        let realTitle = tmpRule.label.split('::')[1] || tmpRule.label;
                        let realPerspectiveAbbrev = typeof tmpRule.psp === 'string' ? tmpRule.psp : 'ae';
                        let realOperand = 1;
                        if (logicOperators && Array.isArray(logicOperators[tmpRule.type])) {
                            let tmpOperand = logicOperators[tmpRule.type].find((tmpOperand) => tmpOperand.vueValue === tmpRule.operator);
                            if (tmpOperand) {
                                realOperand = tmpOperand.operandID;
                            }
                        }
                        let tmpClauseValue = Array.isArray(tmpRule.value) && tmpRule.type === 'array' ? tmpRule.value[0] : tmpRule.value;
                        let tmpClauseValueOperand = null;
                        let tmpClauseValueFrom = null;
                        let tmpClauseValueFromOperand = null;
                        let tmpClauseValueTo = null;
                        let tmpClauseValueToOperand = null;
                        let tmpValueAdditionalParam = "";
                        if (typeof tmpRule.value === 'string' && tmpRule.value.indexOf('dateValue') !== -1 && library.isJson(tmpRule.value)) {
                            let tmpValueObj = JSON.parse(tmpRule.value);
                            tmpClauseValue = tmpValueObj.dateValue;
                            if (tmpValueObj.datePeriod) {
                                let tmpRealOperand = 1;
                                if (logicOperators && Array.isArray(logicOperators[tmpRule.type])) {
                                    let tmpOperand = logicOperators[tmpRule.type].find((tmpOperand) => tmpOperand.vueValue === tmpValueObj.datePeriod);
                                    if (tmpOperand) {
                                        tmpRealOperand = tmpOperand.operandID;
                                    }
                                }
                                tmpClauseValueOperand = tmpRealOperand;
                            }
                            tmpClauseValueFrom = tmpValueObj.dateValueFrom;
                            if (tmpValueObj.datePeriodFrom) {
                                let tmpRealOperand = 1;
                                if (logicOperators && Array.isArray(logicOperators[tmpRule.type])) {
                                    let tmpOperand = logicOperators[tmpRule.type].find((tmpOperand) => tmpOperand.vueValue === tmpValueObj.datePeriodFrom);
                                    if (tmpOperand) {
                                        tmpRealOperand = tmpOperand.operandID;
                                    }
                                }
                                tmpClauseValueFromOperand = tmpRealOperand;
                            }
                            tmpClauseValueTo = tmpValueObj.dateValueTo;
                            if (tmpValueObj.datePeriodTo) {
                                let tmpRealOperand = 1;
                                if (logicOperators && Array.isArray(logicOperators[tmpRule.type])) {
                                    let tmpOperand = logicOperators[tmpRule.type].find((tmpOperand) => tmpOperand.vueValue === tmpValueObj.datePeriodTo);
                                    if (tmpOperand) {
                                        tmpRealOperand = tmpOperand.operandID;
                                    }
                                }
                                tmpClauseValueToOperand = tmpRealOperand;
                            }
                            if (tmpValueObj.valueAdditionalParam) {
                                tmpValueAdditionalParam = tmpValueObj.valueAdditionalParam;
                            }
                        }
                        let tmpGridFieldName = tmpRule.field;
                        let tmpRealPsp = tmpRule.psp;
                        let addTitle = '';
                        let tmpLbeType = null;
                        if (tmpRule.psp === 'lbe' || tmpRule.psp === 'waiver' || tmpRule.psp === 'training') {
                            tmpRealPsp = 'lbe';
                            realPerspectiveAbbrev = 'lbe';
                            addTitle += 'Logged Data/';
                            tmpGridFieldName = tmpGridFieldName.replace('lbe:::', '').replace('waiver:::', '').replace('training:::', '');
                            switch (tmpRule.psp) {
                                case 'lbe':
                                    tmpLbeType = 0;
                                    break;
                                case 'waiver':
                                    tmpLbeType = 5;
                                    break;
                                case 'training':
                                    tmpLbeType = 6;
                                    break;
                            }
                        } else {
                            tmpGridFieldName = tmpGridFieldName.replace(tmpRule.psp + ':::', '');
                        }
                        let pspFields = configStore.state.cfg.availableLogicClauses;
                        let caCode = null;
                        if (pspFields && pspFields[tmpRealPsp]) {
                            let tmpPspFields = Object.values(pspFields[tmpRealPsp]);
                            let field = tmpPspFields.find((tmp) => 'CA#' + tmp.CUSTOM_ATTRIBUTE_CODE === tmpGridFieldName);
                            if (field) {
                                caCode = field.CUSTOM_ATTRIBUTE_CODE;
                                tmpGridFieldName = 'CUSTOM_ATTRIBUTE#' + field.CUSTOM_ATTRIBUTE_ID;
                            }
                        }
                        let tmpClauseInfo = {
                            "PERSPECTIVE": realPerspective,
                            "IS_LOGBOOK": "N",
                            "CLAUSE_TITLE": library.capitalizeFirstLetter(tmpRealPsp) + ':' + addTitle + realTitle,
                            "CLAUSE_VALUE": tmpClauseValue || "",
                            "FLT_CLAUSE_VALUE_OPERAND": tmpClauseValueOperand,
                            "FLT_CLAUSE_VALUE_FROM": tmpClauseValueFrom,
                            "FLT_CLAUSE_VALUE_FROM_OPERAND": tmpClauseValueFromOperand,
                            "FLT_CLAUSE_VALUE_TO": tmpClauseValueTo,
                            "FLT_CLAUSE_VALUE_TO_OPERAND": tmpClauseValueToOperand,
                            "FLT_SELECT_FIELD_PERSPECTIVE_ABBREV": realPerspectiveAbbrev,
                            "GRID_FIELD_NAME": tmpGridFieldName,
                            "FLT_CLAUSE_PSP_OPTION": tmpRule.additionalParam || null,
                            "FLT_CLAUSE_VALUE_ADDITIONAL_PARAM": tmpValueAdditionalParam,
                            "LBE_TYPE": tmpLbeType,
                            "FLT_CLAUSE_DATE_FROM": "",
                            "FLT_CLAUSE_DATE_TO": "",
                            "IS_PREREQUISITE": "N",
                            "OPERAND": realOperand,
                            "clause_type": tmpRule.type,
                            "display_title": tmpRule.label
                        };
                        if (caCode) tmpClauseInfo["CUSTOM_ATTRIBUTE_CODE"] = caCode;
                        result['[FilterEditor::FiltersColumns]'].push(tmpClauseInfo);
                    }
                }
            }
            let rulesString = library.getRulesString(logicObject);
            let fIndex = 0;
            rulesString = rulesString.trim().replace(/__field__/g, function () {
                fIndex++;
                return fIndex;
            });
            rulesString = rulesString.replaceAll('  ', ' ').replaceAll(' ', ',');
            result['[FilterEditor::Filters]'] = [{
                "PERSPECTIVE": realPerspective,
                "ACCOUNT_SPECIFIC": "Y",
                "IS_LOGBOOK": "N",
                "FILTER_LINK": null,
                "RULE": rulesString,
                "IS_PREREQUISITE": "N",
                "CONTEXT_SPECIFIC": "N"
            }];
        }
        return result;
    },
    logicMappedType(type) {
        let output;
        type = type && type.toLowerCase();
        switch (type) {
            case 'string':
            case 'url':
            case 'list':
            case 'dropdown':
            case 'attachment':
            case 'special_string':
                output = 'string';
                break;
            case 'text':
                output = 'text';
                break;
            case 'date':
            case 'datetime':
                output = 'date';
                break;
            case 'time':
                output = 'time';
                break;
            case 'integer':
            case 'float':
            case 'number':
            case 'numeric':
            case 'numeric_id':
                output = 'numeric';
                break;
            case 'date_period':
                output = 'date_period';
                break;
            case 'boolean':
                output = 'boolean';
                break;
            case 'array':
            case 'dropdowntree':
            case 'multiselect':
                output = 'array';
                break;
            default:
                output = 'string';
        }
        return output;
    },
    async prepLogicParsingToFront(perspectives) {
        await configStore.getLogicOperatorsList();
        await configStore.getPSPList();
        if (typeof perspectives !== 'undefined') await configStore.allLogicClausesList(perspectives);
    },
    parseLogicToFront(obj, criteriaRecords, forLogicEditor) {
        let logicOperators = configStore.state.cfg.logicOperatorsList;
        let result = {};
        if (typeof obj === 'string' && library.isJson(obj)) obj = JSON.parse(obj);
        if (obj && obj['[FilterEditor::Filters]'] && obj['[FilterEditor::Filters]'][0]) {
            let tmpRule = obj['[FilterEditor::Filters]'][0]['RULE'] || '1';
            let checkRuleString = tmpRule.split(',');
            for (let i in checkRuleString) {
                let checkColumnIdx = parseInt(checkRuleString[i], 10);
                if (checkColumnIdx > 0) {
                    if (!obj['[FilterEditor::FiltersColumns]'][checkColumnIdx - 1]) {
                        tmpRule = tmpRule.replace(checkColumnIdx, '');
                    }
                }
            }
            let qb = new QueryBuilder();
            let sqlString = tmpRule.replaceAll(',', ' ').replaceAll(/(\d+)/gm, '__field__ = 1');
            result = qb.getRulesFromSql(sqlString);
            let validResult = qb.getValidRules();
            if (!library.objIsEmpty(validResult)) {
                result = validResult;
            }
            let flattenResult = library.flatten(result);
            let ruleIdx = 0;
            for (let i in flattenResult) {
                if (i.endsWith('.field')) {
                    let tmpRule = obj['[FilterEditor::FiltersColumns]'][ruleIdx];
                    if (!tmpRule || !tmpRule.clause_type) {
                        continue;
                    }
                    let tmpPspAbbrev = tmpRule.FLT_SELECT_FIELD_PERSPECTIVE_ABBREV;
                    let fieldType = library.logicMappedType(tmpRule.clause_type || 'string');
                    if (logicOperators[fieldType]) {
                        let findOperator = (tmpLogicOperators, tmpOperand) => tmpLogicOperators.find((tmpOperator) => tmpOperator.operandID === parseInt(tmpOperand, 10));
                        let tmpOperator = findOperator(logicOperators[fieldType], tmpRule.OPERAND);
                        if (tmpOperator) {
                            let tmpValue = fieldType === 'numeric' ? parseInt(tmpRule.CLAUSE_VALUE, 10) : tmpRule.CLAUSE_VALUE;
                            let tmpValueAdditionalParam = tmpRule.FLT_CLAUSE_VALUE_ADDITIONAL_PARAM;
                            if (fieldType === 'date') {
                                let datePeriodOperands = ['FLT_CLAUSE_VALUE_FROM_OPERAND', 'FLT_CLAUSE_VALUE_TO_OPERAND', 'FLT_CLAUSE_VALUE_OPERAND'];
                                let tmpDatePeriod = {};
                                for (let tmpDatePeriodIndex in datePeriodOperands) {
                                    let tmpDatePeriodName = datePeriodOperands[tmpDatePeriodIndex];
                                    tmpDatePeriod[tmpDatePeriodName] = 0;
                                    if (tmpRule[tmpDatePeriodName]) {
                                        let tmpOperator = findOperator(logicOperators[fieldType], tmpRule[tmpDatePeriodName]);
                                        if (tmpOperator) tmpDatePeriod[tmpDatePeriodName] = tmpOperator.vueValue;
                                    }
                                }
                                let newValue = {
                                    "datePeriodFrom": tmpDatePeriod['FLT_CLAUSE_VALUE_FROM_OPERAND'],
                                    "dateValueFrom": tmpRule.FLT_CLAUSE_VALUE_FROM || null,
                                    "datePeriodTo": tmpDatePeriod['FLT_CLAUSE_VALUE_TO_OPERAND'],
                                    "dateValueTo": tmpRule.FLT_CLAUSE_VALUE_TO || null,
                                    "datePeriod": tmpDatePeriod['FLT_CLAUSE_VALUE_OPERAND'],
                                    "dateValue": tmpValue || null,
                                    "valueAdditionalParam": tmpValueAdditionalParam || ""
                                };
                                tmpValue = JSON.stringify(newValue);
                            }
                            let criteriaRecord;
                            let recordId;
                            if (Array.isArray(criteriaRecords)) {
                                if (typeof criteriaRecords[ruleIdx] === 'object') {
                                    ({ criteriaRecord, recordId } = criteriaRecords[ruleIdx]);
                                }
                            }
                            let tmpPrefix = '';
                            let tmpFieldPrefix = forLogicEditor ? tmpPspAbbrev + ':::' : '';
                            if (tmpPspAbbrev === 'lbe') {
                                switch (tmpRule.LBE_TYPE) {
                                    case 0:
                                        // eslint-disable-next-line no-multi-assign
                                        tmpPrefix = tmpFieldPrefix = 'lbe:::';
                                        break;
                                    case 5:
                                        // eslint-disable-next-line no-multi-assign
                                        tmpPrefix = tmpFieldPrefix = 'waiver:::';
                                        tmpPspAbbrev = 'waiver';
                                        break;
                                    case 6:
                                        // eslint-disable-next-line no-multi-assign
                                        tmpPrefix = tmpFieldPrefix = 'training:::';
                                        tmpPspAbbrev = 'training';
                                        break;
                                }
                            }
                            if (!forLogicEditor && tmpPspAbbrev === 'aff' && tmpRule.FLT_CLAUSE_PSP_OPTION === 1) tmpPspAbbrev = 'assignment';
                            let rule = {
                                "label": tmpPrefix + (tmpRule.display_title || ''),
                                "field": tmpFieldPrefix + (tmpRule.CUSTOM_ATTRIBUTE_CODE ? 'CA#' + tmpRule.CUSTOM_ATTRIBUTE_CODE : tmpRule.GRID_FIELD_NAME),
                                "operator": tmpOperator.vueValue,
                                "type": fieldType,
                                "value": tmpValue,
                                "psp": tmpPspAbbrev,
                                "criteriaRecord": criteriaRecord,
                                "additionalParam": tmpRule.FLT_CLAUSE_PSP_OPTION || tmpRule.FLT_CLAUSE_PSP_OPTION === 0 ? tmpRule.FLT_CLAUSE_PSP_OPTION + '' : null,
                                "valueAdditionalParam": tmpValueAdditionalParam + '',
                                "recordId": recordId
                            };
                            library.setByPath(result, i.replace(/(.field$)/, ''), rule);
                            ruleIdx++;
                        }
                    }
                }
            }
        }
        return result;
    },
    /* istanbul ignore next */
    openInNewTab(href) {
        Object.assign(document.createElement('a'), {
            target: '_blank',
            rel: 'noopener noreferrer',
            href: href,
        }).click();
    },
    /* istanbul ignore next */
    getDaysInMonth(month, year) {
        if (!year) year = new Date().getFullYear();
        return new Date(year, month, 0).getDate();
    },
    stringToColor(str, alpha = '100%', saturation = '60%', lightness = '55%') {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash * 32) - hash);
        }

        const hue = Math.abs(hash) % 360;
        return `hsla(${hue}, ${saturation}, ${lightness}, ${alpha})`;
    },
    /* istanbul ignore next */
    // eslint-disable-next-line consistent-return
    onElementVisible(element, callback, isMultiple) {
        if (typeof IS_JEST !== 'undefined') return false;
        new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry?.target?.checkVisibility?.()) {
                    callback(element);
                    if (!isMultiple) observer.disconnect();
                }
            });
        }).observe(element);
        // eslint-disable-next-line no-return-assign
        if (!callback) return new Promise((r) => callback = r);
    },
    /* istanbul ignore next */
    // eslint-disable-next-line consistent-return
    onElementResize(element, callback, isMultiple) {
        if (typeof IS_JEST !== 'undefined') return false;
        new ResizeObserver((entries, observer) => {
            entries.forEach((entry) => {
                callback(element);
                if (!isMultiple) observer.disconnect();
            });
        }).observe(element);
        // eslint-disable-next-line no-return-assign
        if (!callback) return new Promise((r) => callback = r);
    },
    async interpolateOptions(options, optionsText, template, recordStore) {
        try {
            let _this = this;
            for (let i in options) {
                // eslint-disable-next-line no-await-in-loop
                options[i][optionsText] = await renderToString(
                    h({
                        props: {
                            template: {
                                default: ""
                            },
                            props: {
                                default: {}
                            }
                        },
                        render() {
                            let tmpTemplate = this.template;
                            if (typeof this.template !== 'function') {
                                tmpTemplate = compile(tmpTemplate);
                            }
                            return h(tmpTemplate(this));
                        },
                        computed: {
                            record() {
                                return this.props;
                            },
                            records() {
                                return _this.recordStore.records;
                            }
                        },
                        methods: {
                            getThis() {
                                return _this;
                            }
                        }
                    }, { template: template, props: options[i] })
                );
            }
            return options;
        } catch (e) {
            return options;
        }
    }
};

window['library'] = library;

export { library, dialogs };
